import { openBlock as i, createElementBlock as h, createElementVNode as d, toDisplayString as p, pushScopeId as ee, popScopeId as te, normalizeClass as $, Fragment as F, renderList as R, createCommentVNode as B, resolveComponent as L, resolveDirective as me, withModifiers as Se, createVNode as q, normalizeStyle as T, withDirectives as ie, createBlock as se, createTextVNode as W, vShow as ve, vModelText as Ze, renderSlot as E, useCssVars as be, withCtx as ae, ref as P, watch as ge, computed as x, onMounted as ye, onUnmounted as Qe, nextTick as ke, Transition as Ve, toRefs as Je, inject as Pe } from "vue";
const A = (e, o) => {
  const t = e.__vccOpts || e;
  for (const [a, n] of o)
    t[a] = n;
  return t;
}, et = {
  name: "TestemunhoRow",
  props: ["nome", "depoimento", "curso", "imagem"]
}, tt = (e) => (ee("data-v-c6671e1b"), e = e(), te(), e), ot = { class: "wrapper" }, at = /* @__PURE__ */ tt(() => /* @__PURE__ */ d("h1", null, "\u201C", -1)), st = { class: "person" }, nt = ["src"];
function rt(e, o, t, a, n, s) {
  return i(), h("div", ot, [
    at,
    d("p", null, p(t.depoimento), 1),
    d("div", st, [
      d("img", { src: t.imagem }, null, 8, nt),
      d("h2", null, p(t.nome) + " - " + p(t.curso), 1)
    ])
  ]);
}
const it = /* @__PURE__ */ A(et, [["render", rt], ["__scopeId", "data-v-c6671e1b"]]);
const lt = {
  props: ["numberOfDots", "showDots", "currentSlideIndex", "colorClass"],
  emits: ["clickedDot"],
  methods: {
    changePage(e) {
      this.$emit("clickedDot", e - 1);
    }
  }
}, dt = ["onClick"];
function ct(e, o, t, a, n, s) {
  return t.numberOfDots > 1 && t.showDots != !1 ? (i(), h("div", {
    key: 0,
    class: $(["dots", { lots: t.numberOfDots > 9 }])
  }, [
    (i(!0), h(F, null, R(t.numberOfDots, (l) => (i(), h("div", {
      class: $(["dot", [{ active: l == t.currentSlideIndex + 1 }, t.colorClass]]),
      onClick: (r) => s.changePage(l),
      key: l
    }, null, 10, dt))), 128))
  ], 2)) : B("", !0);
}
const ut = /* @__PURE__ */ A(lt, [["render", ct], ["__scopeId", "data-v-32cdfb90"]]);
const ht = {
  props: ["className", "showNavigation"],
  emits: ["slideNext", "slideBack"]
}, Ke = (e) => (ee("data-v-622d57f5"), e = e(), te(), e), _t = /* @__PURE__ */ Ke(() => /* @__PURE__ */ d("i", { class: "chev i ms-Icon ms-Icon--ChevronRight" }, null, -1)), gt = [
  _t
], mt = /* @__PURE__ */ Ke(() => /* @__PURE__ */ d("i", { class: "chev i ms-Icon ms-Icon--ChevronLeft" }, null, -1)), ft = [
  mt
];
function pt(e, o, t, a, n, s) {
  return i(), h(F, null, [
    t.showNavigation ? (i(), h("a", {
      key: 0,
      class: $(["botao next", t.className]),
      onClick: o[0] || (o[0] = (l) => e.$emit("slideNext"))
    }, gt, 2)) : B("", !0),
    t.showNavigation ? (i(), h("a", {
      key: 1,
      class: $(["botao previous", t.className]),
      onClick: o[1] || (o[1] = (l) => e.$emit("slideBack"))
    }, ft, 2)) : B("", !0)
  ], 64);
}
const vt = /* @__PURE__ */ A(ht, [["render", pt], ["__scopeId", "data-v-622d57f5"]]), bt = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAAaADAAQAAAABAAAAAQAAAAD5Ip3+AAAAC0lEQVQIHWNgAAIAAAUAAY27m/MAAAAASUVORK5CYII=";
const yt = {
  beforeMount: (e, o) => {
    const t = o.value;
    window.addEventListener("resize", () => {
      const a = Array.from(
        document.querySelectorAll(".testemunho .slidewrapper")
      ), n = Math.max(...a.map((s) => s.offsetHeight));
      t(n);
    });
  },
  updated(e, o) {
    const t = o.value, a = Array.from(
      document.querySelectorAll(".testemunho .slidewrapper")
    ), n = Math.max(...a.map((s) => s.offsetHeight));
    t(n);
  },
  unmounted: (e) => {
    document.removeEventListener("resize", e.resize);
  }
}, Ct = 0.1 * 2, $e = document.getElementById("app").offsetWidth, St = $e - $e * Ct;
let ce = St;
const fe = 1280, pe = 900, kt = {
  name: "WebSlider",
  props: ["items", "showdots"],
  emits: ["slideItemClicked"],
  components: {
    TestemunhoRow: it,
    SliderDots: ut,
    SliderNavigation: vt
  },
  data() {
    return {
      resizeObserver: null,
      currentSlideIndex: 0,
      currentSlide: null,
      slides: [],
      slideHeight: 0,
      startPoint: 0,
      sliderWidth: ce,
      elementsPerSlide: 3,
      isDragging: !1,
      slideWrapperPosition: 0,
      colorClass: "",
      isSliding: !1
    };
  },
  computed: {
    nextSlideIndex() {
      const e = this.slides.length - 1;
      return this.currentSlideIndex == e ? 0 : this.currentSlideIndex + 1;
    },
    previousSlideIndex() {
      return this.currentSlideIndex == 0 ? this.slides.length - 1 : this.currentSlideIndex - 1;
    },
    currentSlidePosition() {
      return this.slides[this.currentSlideIndex].position;
    },
    previousSlidePosition() {
      return this.slides[this.previousSlideIndex].position;
    },
    nextSlidePosition() {
      return this.slides[this.nextSlideIndex].position;
    }
  },
  created() {
    this.colorClass = this.items[0]?.Faculdade.name, this.setNumberOfElementsOnSlides(), this.initSlides();
  },
  mounted() {
    this.resizeObserver = new ResizeObserver(() => {
      this.equalizeSlidesHeight();
    }), this.resizeObserver.observe(this.$refs.sld0[0]), window.addEventListener("resize", () => {
      const o = this.slides.length, t = this.currentSlideIndex;
      this.setNumberOfElementsPerSlide(), this.slides.length != o && (this.currentSlideIndex = this.getUpdatedIndex(t, this.elementsPerSlide)), this.moveSlide(-this.currentSlidePosition);
    });
    const e = document.querySelector(".casosslider");
    e.addEventListener("transitionstart", () => {
      this.isSliding = !0;
    }), e.addEventListener("transitionend", () => {
      this.isSliding = !1, this.needsToRecalculateSlidePosition() && this.recalculatePreviousSlidePosition();
    }), this.setSlidesPosition(), this.equalizeSlidesHeight();
  },
  unmounted() {
    this.resizeObserver = null, window.removeEventListener("resize", window);
  },
  methods: {
    changePage(e) {
      if (this.currentSlideIndex < e) {
        const o = e - this.currentSlideIndex;
        for (let t = 0; t < o; t++)
          this.slideNext();
      } else {
        const o = this.currentSlideIndex - e;
        for (let t = 0; t < o; t++)
          this.slideBack();
      }
    },
    onTouchStart(e) {
      this.slides.length > 1 ? (this.isDragging = !0, this.startPoint = e.changedTouches[0].clientX) : e.preventDefault();
    },
    onTouchMove(e) {
      const o = e.changedTouches[0].clientX;
      this.isDraggingToRight(o) ? this.dragSlideToRight(o) : this.dragSlideToleft(o);
    },
    onTouchEnd(e) {
      this.isDragging = !1, e.changedTouches[0].clientX - this.startPoint > 0 ? this.shouldGoToPreviousSlide() ? this.slideBack() : this.moveSlide(-this.currentSlidePosition) : this.shouldGoToNextSlide() ? this.slideNext() : this.moveSlide(-this.currentSlidePosition);
    },
    startDrag(e, o) {
      if (this.slides.length > 1) {
        this.isDragging = !0, e.dataTransfer.dropEffect = "none", e.dataTransfer.effectAllowed = "move";
        const t = document.getElementById("dragimage");
        e.dataTransfer.setDragImage(t, 0, 0), e.dataTransfer.setData("itemID", o.position), this.startPoint = e.pageX;
      } else
        e.preventDefault();
    },
    onDrop(e) {
      this.isDragging = !1, e.pageX - this.startPoint > 0 ? this.shouldGoToPreviousSlide() ? this.slideBack() : this.moveSlide(-this.currentSlidePosition) : this.shouldGoToNextSlide() ? this.slideNext() : this.moveSlide(-this.currentSlidePosition);
    },
    dragSlide(e) {
      let { pageX: o } = e;
      this.isDraggingToRight(o) ? this.dragSlideToRight(o) : this.dragSlideToleft(o);
    },
    isDraggingToRight(e) {
      return e - this.startPoint > 0;
    },
    dragSlideToleft(e) {
      let o = e - this.startPoint;
      if (this.beforeSlideNextCheckAndUpdatePosition(), this.currentSlidePosition > 0)
        this.moveSlide(-(this.currentSlidePosition - o));
      else {
        let t = this.currentSlidePosition >= 0 ? this.currentSlidePosition + o : Math.abs(this.currentSlidePosition - o);
        this.moveSlide(t);
      }
    },
    dragSlideToRight(e) {
      let o = e - this.startPoint;
      if (this.beforeSlideBackCheckAndUpdatePosition(), this.currentSlidePosition > 0)
        this.moveSlide(-(this.currentSlidePosition - o));
      else {
        let t = Math.abs(this.currentSlidePosition - o);
        this.moveSlide(t);
      }
    },
    beforeSlideNextCheckAndUpdatePosition() {
      this.nextSlidePosition < this.currentSlidePosition && (this.slides[this.nextSlideIndex].position = this.currentSlidePosition + ce);
    },
    beforeSlideBackCheckAndUpdatePosition() {
      this.previousSlidePosition > this.currentSlidePosition && (this.slides[this.previousSlideIndex].position = this.currentSlidePosition - ce);
    },
    shouldGoToNextSlide() {
      const e = Math.abs(
        Math.abs(this.currentSlidePosition) - Math.abs(this.slideWrapperPosition)
      );
      return Math.abs(
        Math.abs(this.nextSlidePosition) - Math.abs(this.slideWrapperPosition)
      ) < e;
    },
    shouldGoToPreviousSlide() {
      const e = Math.abs(
        Math.abs(this.currentSlidePosition) - Math.abs(this.slideWrapperPosition)
      );
      return Math.abs(
        Math.abs(this.previousSlidePosition) - Math.abs(this.slideWrapperPosition)
      ) < e;
    },
    changeTestemunho(e) {
      this.$emit("slideItemClicked", e);
    },
    getUpdatedIndex(e, o) {
      let t = Math.ceil(e / o);
      return t == 0 ? 0 : t - 1;
    },
    setNumberOfElementsOnSlides() {
      const o = document.getElementsByTagName("body")[0].clientWidth;
      o > fe && this.elementsPerSlide != 3 && (this.elementsPerSlide = 3), o < fe && o > pe && this.elementsPerSlide != 2 && (this.elementsPerSlide = 2), o < pe && this.elementsPerSlide != 1 && (this.elementsPerSlide = 1);
    },
    setNumberOfElementsPerSlide() {
      const o = document.getElementsByTagName("body")[0].clientWidth;
      o > fe && this.elementsPerSlide != 3 && (this.elementsPerSlide = 3, this.initSlides()), o < fe && o > pe && this.elementsPerSlide != 2 && (this.elementsPerSlide = 2, this.initSlides()), o < pe && this.elementsPerSlide != 1 && (this.elementsPerSlide = 1, this.initSlides()), this.setSlidesPosition(), this.equalizeSlidesHeight();
    },
    equalizeSlidesHeight() {
      this.getMaximumHeigthText();
      let e = 0;
      this.slides.map((o, t) => {
        if (this.$refs[`sld${t}`] != null) {
          let n = this.$refs[`sld${t}`][0]?.offsetHeight;
          n > e && (e = n);
        }
      }), this.slideHeight = e;
    },
    initSlides() {
      const e = [...this.items], o = Math.ceil(this.items.length / this.elementsPerSlide);
      this.slides = new Array(o).fill(1).map(() => e.splice(0, this.elementsPerSlide)).map((t) => ({
        elements: t
      }));
    },
    setSlidesPosition() {
      ce = this.calculateSliderWidth(), this.slides = this.slides.map((e, o) => {
        const t = Math.ceil(this.items.length / this.elementsPerSlide);
        let a = 0;
        return t > 1 && (a = o < t - 1 ? o * ce : -ce), {
          ...e,
          position: a
        };
      });
    },
    calculateSliderWidth() {
      var e = window.getComputedStyle(document.querySelector(".paddingwrapper"), null);
      const o = parseFloat(e.getPropertyValue("padding-left")), t = parseFloat(e.getPropertyValue("padding-right"));
      return document.querySelector(".paddingwrapper").clientWidth - o - t;
    },
    getMaximumHeigthText() {
      const e = document.querySelectorAll(".casosslider .testemunhoItem p"), o = Array.from(e), t = Math.max(...o.map((l) => l.offsetHeight));
      e.forEach((l) => {
        let r = t - l.offsetHeight + 16;
        l.setAttribute(
          "style",
          `margin-bottom: ${r}px`
        );
      });
      const a = document.querySelectorAll(".casosslider .person"), n = Array.from(a), s = Math.max(...n.map((l) => l.offsetHeight));
      a.forEach((l) => {
        l.setAttribute(
          "style",
          `min-height: ${s}px`
        );
      });
    },
    setDimensions(e) {
      this.slideHeight = e, this.equalizeSlidesHeight(), this.getMaximumHeigthText();
    },
    recalculatePreviousSlidePosition() {
      this.previousSlidePosition > this.currentSlidePosition && (this.slides[this.previousSlideIndex].position = this.currentSlidePosition - ce);
    },
    needsToRecalculateSlidePosition() {
      return this.previousSlidePosition > this.currentSlidePosition;
    },
    slideBack() {
      this.isSliding || (this.currentSlideIndex = this.previousSlideIndex, this.moveSlide(-this.currentSlidePosition));
    },
    slideNext() {
      this.isSliding || (this.calculatePositionForNextSlides(), this.moveSlide(-this.currentSlidePosition));
    },
    calculatePositionForNextSlides() {
      this.currentSlideIndex = this.nextSlideIndex, this.slides[this.currentSlideIndex].position = this.previousSlidePosition + ce;
    },
    moveSlide(e) {
      this.slideWrapperPosition = e;
    }
  },
  directives: {
    resize: yt
  }
}, It = (e) => (ee("data-v-e2506ba4"), e = e(), te(), e), wt = /* @__PURE__ */ It(() => /* @__PURE__ */ d("img", {
  src: bt,
  id: "dragimage"
}, null, -1)), Dt = ["onDragstart"];
function xt(e, o, t, a, n, s) {
  const l = L("SliderNavigation"), r = L("TestemunhoRow"), v = L("SliderDots"), m = me("resize");
  return i(), h(F, null, [
    wt,
    d("div", {
      onDragover: o[4] || (o[4] = Se(() => {
      }, ["prevent"])),
      onDragenter: o[5] || (o[5] = Se(() => {
      }, ["prevent"])),
      onDrop: o[6] || (o[6] = (...f) => s.onDrop && s.onDrop(...f)),
      class: "paddingwrapper",
      id: "stage"
    }, [
      q(l, {
        onSlideBack: s.slideBack,
        onSlideNext: s.slideNext,
        className: n.slides[0].elements[0].Faculdade.name,
        showNavigation: this.slides.length > 1
      }, null, 8, ["onSlideBack", "onSlideNext", "className", "showNavigation"]),
      d("div", {
        class: "hiddenwrapper",
        style: T({ height: `${n.slideHeight}px` })
      }, [
        ie((i(), h("div", {
          class: $(["row casosslider", { drag: n.isDragging }]),
          style: T({ transform: `translateX(${n.slideWrapperPosition}px)` })
        }, [
          (i(!0), h(F, null, R(n.slides, (f, u) => (i(), h("div", {
            key: u,
            style: T({ transform: `translateX(${f.position}px)` }),
            class: $(["small-12 medium-12 large-12 columns testemunho", { active: u == n.currentSlide }])
          }, [
            d("div", {
              class: "row slidewrapper",
              onDrag: o[0] || (o[0] = (...c) => s.dragSlide && s.dragSlide(...c)),
              onDragstart: (c) => s.startDrag(c, f),
              draggable: "true",
              onTouchstartPassive: o[1] || (o[1] = (...c) => s.onTouchStart && s.onTouchStart(...c)),
              onTouchmovePassive: o[2] || (o[2] = (...c) => s.onTouchMove && s.onTouchMove(...c)),
              onTouchendPassive: o[3] || (o[3] = (...c) => s.onTouchEnd && s.onTouchEnd(...c)),
              ref_for: !0,
              ref: `sld${u}`
            }, [
              (i(!0), h(F, null, R(f.elements, (c, S) => (i(), h("div", {
                class: $(["columns small-4", {
                  "small-6": n.elementsPerSlide === 2,
                  "small-12": n.elementsPerSlide === 1
                }]),
                key: c.ID
              }, [
                (i(), se(r, {
                  onClick: (C) => s.changeTestemunho(c),
                  class: $(["testemunhoItem", c.Faculdade.name]),
                  nome: c.Identificacao,
                  depoimento: c.Depoimento,
                  curso: c.Curso.post_title,
                  imagem: c.Imagem,
                  key: S
                }, null, 8, ["onClick", "class", "nome", "depoimento", "curso", "imagem"]))
              ], 2))), 128))
            ], 40, Dt)
          ], 6))), 128))
        ], 6)), [
          [m, s.setDimensions]
        ])
      ], 4)
    ], 32),
    q(v, {
      onClickedDot: s.changePage,
      numberOfDots: this.slides.length,
      showDots: this.slides.length > 1 && this.showdots != !1,
      currentSlideIndex: n.currentSlideIndex,
      colorClass: n.colorClass
    }, null, 8, ["onClickedDot", "numberOfDots", "showDots", "currentSlideIndex", "colorClass"])
  ], 64);
}
const dn = /* @__PURE__ */ A(kt, [["render", xt], ["__scopeId", "data-v-e2506ba4"]]);
const At = {
  beforeMount: (e, o) => {
    e.clickOutsideEvent = (t) => {
      e == t.target || e.contains(t.target) || o.value();
    }, document.addEventListener("click", e.clickOutsideEvent);
  },
  unmounted: (e) => {
    document.removeEventListener("click", e.clickOutsideEvent);
  }
}, Pt = {
  name: "ComboBox",
  props: ["modelValue", "defaultmsg", "options", "isOpen", "caretend", "disablenull"],
  emits: ["update:modelValue", "update:openCombo", "update:closeCombo", "clickOutside"],
  methods: {
    clickedOutside() {
      this.$emit("clickOutside");
    },
    handleInput(e) {
      let o = e;
      this.disablenull ? e == this.modelValue && (o = this.modelValue) : o = e != this.modelValue ? e : null, this.$emit("update:modelValue", o), this.$emit("update:closeCombo");
    },
    switchOption() {
      this.$emit("update:openCombo");
    }
  },
  directives: {
    clickOutside: At
  }
}, $t = (e) => (ee("data-v-920f6e44"), e = e(), te(), e), Tt = { class: "option" }, Ot = {
  key: 0,
  class: "value"
}, Ht = {
  key: 1,
  class: "result"
}, Ft = /* @__PURE__ */ $t(() => /* @__PURE__ */ d("span", { class: "drop_linha" }, null, -1)), Et = { class: "drop" }, Mt = ["onClick"], Lt = { class: "opt" }, Wt = {
  key: 0,
  class: "cicloremove ms-Icon ms-Icon--Cancel",
  "aria-hidden": "true"
};
function Bt(e, o, t, a, n, s) {
  const l = me("clickOutside");
  return ie((i(), h("div", Tt, [
    d("a", {
      class: $(["dropdownbtn", { end: t.caretend == !0 }]),
      "data-toggle": "grauDropDown",
      onClick: o[0] || (o[0] = (...r) => s.switchOption && s.switchOption(...r))
    }, [
      d("i", {
        class: $(["fa", {
          "fa-chevron-down": !t.isOpen,
          "fa-chevron-up": t.isOpen
        }])
      }, null, 2),
      t.modelValue == null ? (i(), h("span", Ot, p(t.defaultmsg), 1)) : (i(), h("span", Ht, p(t.modelValue.label), 1)),
      Ft
    ], 2),
    d("div", {
      class: $(["dropdown-pane", { "is-open": t.isOpen }]),
      id: "grauDropDown",
      "data-dropdown": ""
    }, [
      d("ul", Et, [
        (i(!0), h(F, null, R(t.options, (r) => (i(), h("li", {
          class: $({ active: r == t.modelValue }),
          key: r.title,
          onClick: (v) => s.handleInput(r)
        }, [
          d("a", Lt, [
            W(p(r.label) + " ", 1),
            t.disablenull != !0 ? (i(), h("i", Wt)) : B("", !0)
          ])
        ], 10, Mt))), 128))
      ])
    ], 2)
  ])), [
    [l, s.clickedOutside]
  ]);
}
const cn = /* @__PURE__ */ A(Pt, [["render", Bt], ["__scopeId", "data-v-920f6e44"]]);
const Nt = {
  beforeMount: (e, o) => {
    e.clickOutsideEvent = (t) => {
      e == t.target || e.contains(t.target) || o.value();
    }, document.addEventListener("click", e.clickOutsideEvent);
  },
  unmounted: (e) => {
    document.removeEventListener("click", e.clickOutsideEvent);
  }
}, Rt = {
  name: "ComboBoxSearch",
  props: [
    "modelValue",
    "defaultmsg",
    "options",
    "caretend",
    "isOpen",
    "bordercolor",
    "optionsStyle",
    "droppaneStyle",
    "droppaneClass",
    "dropClass",
    "optionClass",
    "closeOnClickOutside"
  ],
  emits: ["update:modelValue", "update:toggleCombo", "update:closeCombo", "clickOutside"],
  data() {
    return {
      currentVal: ""
    };
  },
  computed: {
    availableOptions() {
      return this.options.filter((e) => e.label.toLowerCase().includes(this.currentVal.toLowerCase()));
    },
    chevronClass() {
      return this.isOpen ? "fa-chevron-up" : "fa-chevron-down";
    },
    borderColor() {
      return this.bordercolor || "black";
    },
    hasBorderColor() {
      return !!this.bordercolor;
    }
  },
  updated() {
    this.isOpen && this.$nextTick(() => this.$refs.inputbox.focus());
  },
  methods: {
    filterOptions(e) {
      this.currentVal = e.target.value;
    },
    clickedOutside() {
      this.closeOnClickOutside && this.$emit("update:closeCombo"), this.$emit("clickOutside");
    },
    handleInput(e) {
      const o = e != this.modelValue ? e : null;
      this.currentVal = "", this.$emit("update:modelValue", o), this.$emit("update:closeCombo");
    },
    toggleCombo() {
      this.$emit("update:toggleCombo");
    }
  },
  directives: {
    clickOutside: Nt
  }
}, je = (e) => (ee("data-v-6ff5abe1"), e = e(), te(), e), Vt = { class: "option" }, Kt = ["value", "placeholder"], jt = ["value", "placeholder"], zt = /* @__PURE__ */ je(() => /* @__PURE__ */ d("span", { class: "drop_linha" }, null, -1)), Gt = ["onClick"], qt = { class: "opt" }, Xt = /* @__PURE__ */ je(() => /* @__PURE__ */ d("i", {
  class: "cicloremove ms-Icon ms-Icon--Cancel",
  "aria-hidden": "true"
}, null, -1));
function Yt(e, o, t, a, n, s) {
  const l = me("clickOutside");
  return ie((i(), h("div", Vt, [
    d("a", {
      class: $(["dropdownbtn", { end: t.caretend == !0 }]),
      style: T({ "--border-color": t.bordercolor }),
      "data-toggle": "grauDropDown",
      onClick: o[1] || (o[1] = (...r) => s.toggleCombo && s.toggleCombo(...r))
    }, [
      d("i", {
        class: $(["fa", s.chevronClass])
      }, null, 2),
      ie(d("input", {
        ref: "inputbox",
        class: "value",
        autofocus: "",
        onInput: o[0] || (o[0] = (...r) => s.filterOptions && s.filterOptions(...r)),
        value: n.currentVal,
        placeholder: t.defaultmsg
      }, null, 40, Kt), [
        [ve, t.isOpen]
      ]),
      ie(d("input", {
        class: "value",
        value: t.modelValue?.label,
        placeholder: t.defaultmsg,
        readonly: ""
      }, null, 8, jt), [
        [ve, !t.isOpen]
      ]),
      zt
    ], 6),
    d("div", {
      class: $(["dropdown-pane", [t.droppaneClass, { "is-open": t.isOpen }]]),
      style: T(t.droppaneStyle),
      id: "grauDropDown",
      "data-dropdown": ""
    }, [
      d("ul", {
        class: $(["drop", t.dropClass])
      }, [
        (i(!0), h(F, null, R(s.availableOptions, (r) => (i(), h("li", {
          class: $([t.optionClass, { active: r == t.modelValue }]),
          style: T(t.optionsStyle),
          key: r.title,
          onClick: (v) => s.handleInput(r)
        }, [
          d("a", qt, [
            W(p(r.label) + " ", 1),
            Xt
          ])
        ], 14, Gt))), 128))
      ], 2)
    ], 6)
  ])), [
    [l, s.clickedOutside]
  ]);
}
const un = /* @__PURE__ */ A(Rt, [["render", Yt], ["__scopeId", "data-v-6ff5abe1"]]);
const Ut = {
  beforeMount: (e, o) => {
    e.clickOutsideEvent = (t) => {
      e == t.target || e.contains(t.target) || o.value();
    }, document.addEventListener("click", e.clickOutsideEvent);
  },
  unmounted: (e) => {
    document.removeEventListener("click", e.clickOutsideEvent);
  }
}, Zt = {
  name: "ComboSearch",
  props: [
    "modelValue",
    "defaultmsg",
    "options",
    "caretend",
    "bordercolor",
    "optionsStyle",
    "droppaneStyle",
    "droppaneClass",
    "dropClass",
    "optionClass",
    "closeOnClickOutside",
    "disabled"
  ],
  emits: ["update:modelValue", "update:toggleCombo", "update:closeCombo", "clickOutside"],
  data() {
    return {
      isOpen: !1,
      touched: !1,
      filter: "",
      previousFilter: "",
      lineCountRefs: []
    };
  },
  computed: {
    filteredOptions() {
      const e = this.filter.toLowerCase().split(" ");
      return this.options.filter(
        (o) => e.every((t) => o.label.toLowerCase().includes(t))
      );
    },
    chevronClass() {
      if (this.isOpen)
        return "fa-chevron-up";
      let e = "fa-chevron-down";
      return this.disabled && (e = e + " disabled"), e;
    },
    borderColor() {
      return this.bordercolor || "black";
    },
    hasBorderColor() {
      return !!this.bordercolor;
    }
  },
  watch: {
    modelValue: function(e, o) {
      this.filter = e?.label ?? "";
    },
    isOpen: function(e) {
      e && this.$nextTick(() => this.checkLineCounts());
    }
  },
  created() {
    this.filter = this.modelValue?.label ?? "";
  },
  mounted() {
  },
  updated() {
    this.isOpen && this.$nextTick(() => this.$refs.inputbox.focus());
  },
  methods: {
    getRefForOption(e) {
      return `option-${e.value}`;
    },
    checkLineCounts() {
      this.filteredOptions.forEach((e) => {
        const o = this.$refs[this.getRefForOption(e)][0];
        o.clientHeight > 35 ? o.classList.add("two-or-more-lines") : o.classList.remove("two-or-more-lines");
      });
    },
    isActive(e) {
      return e?.value == this.modelValue?.value && this.modelValue != null;
    },
    clickedOutside() {
      this.isOpen && (this.filter = this.previousFilter), this.isOpen = !1, this.$emit("clickOutside");
    },
    handleInput(e) {
      const o = e?.value != this.modelValue?.value ? e : null;
      this.filter = o ? o.label : "", this.isOpen = !1, this.touched = !1, this.$emit("update:modelValue", o), this.$emit("update:closeCombo");
    },
    toggleCombo() {
      this.options.length > 0 && (this.isOpen = !this.isOpen, this.isOpen && (this.previousFilter = this.filter, this.filter = ""));
    }
  },
  directives: {
    clickOutside: Ut
  }
}, Qt = (e) => (ee("data-v-82df783b"), e = e(), te(), e), Jt = { class: "option" }, eo = ["placeholder", "disabled"], to = ["onClick"], oo = /* @__PURE__ */ Qt(() => /* @__PURE__ */ d("i", {
  class: "cicloremove ms-Icon ms-Icon--Cancel",
  "aria-hidden": "true"
}, null, -1));
function ao(e, o, t, a, n, s) {
  const l = me("clickOutside");
  return ie((i(), h("div", Jt, [
    d("a", {
      class: $(["dropdownbtn", { end: t.caretend == !0, disabled: t.disabled }]),
      style: T({ "--border-color": t.bordercolor }),
      "data-toggle": "grauDropDown",
      onClick: o[1] || (o[1] = (...r) => s.toggleCombo && s.toggleCombo(...r))
    }, [
      d("i", {
        class: $(["fa", s.chevronClass])
      }, null, 2),
      ie(d("input", {
        ref: "inputbox",
        class: "value",
        autofocus: "",
        "onUpdate:modelValue": o[0] || (o[0] = (r) => n.filter = r),
        placeholder: t.defaultmsg,
        disabled: t.disabled
      }, null, 8, eo), [
        [Ze, n.filter]
      ])
    ], 6),
    d("div", {
      class: $(["dropdown-pane", [t.droppaneClass, { "is-open": n.isOpen }]]),
      style: T(t.droppaneStyle),
      id: "grauDropDown",
      "data-dropdown": ""
    }, [
      ie(d("ul", {
        class: $(["drop", t.dropClass])
      }, [
        (i(!0), h(F, null, R(s.filteredOptions, (r) => (i(), h("li", {
          class: $([t.optionClass, { active: s.isActive(r) }]),
          style: T(t.optionsStyle),
          key: r.title,
          onClick: (v) => s.handleInput(r)
        }, [
          d("a", {
            class: "opt",
            ref_for: !0,
            ref: s.getRefForOption(r)
          }, [
            W(p(r.label) + " ", 1),
            oo
          ], 512)
        ], 14, to))), 128))
      ], 2), [
        [ve, s.filteredOptions.length > 0 && n.isOpen]
      ])
    ], 6)
  ])), [
    [l, s.clickedOutside]
  ]);
}
const hn = /* @__PURE__ */ A(Zt, [["render", ao], ["__scopeId", "data-v-82df783b"]]);
const Ie = {
  name: "TBotao",
  props: ["backgroundColor", "borderColor", "textColor"]
}, Te = () => {
  be((e) => ({
    "4982b6dc": e.borderColor,
    "06d98ef1": e.textColor,
    "66db9f50": e.backgroundColor
  }));
}, Oe = Ie.setup;
Ie.setup = Oe ? (e, o) => (Te(), Oe(e, o)) : Te;
const so = Ie, no = { class: "botao_style" };
function ro(e, o, t, a, n, s) {
  return i(), h("div", no, [
    d("p", null, [
      E(e.$slots, "default", {}, void 0, !0)
    ])
  ]);
}
const _n = /* @__PURE__ */ A(so, [["render", ro], ["__scopeId", "data-v-a335c36a"]]);
const we = {
  name: "LinkButton"
}, He = () => {
  be((e) => ({
    "9b411b78": e.textColor
  }));
}, Fe = we.setup;
we.setup = Fe ? (e, o) => (He(), Fe(e, o)) : He;
const io = we, lo = { class: "botao_style" };
function co(e, o, t, a, n, s) {
  return i(), h("div", lo, [
    d("p", null, [
      E(e.$slots, "default", {}, void 0, !0)
    ])
  ]);
}
const gn = /* @__PURE__ */ A(io, [["render", co], ["__scopeId", "data-v-f7081c3d"]]);
const uo = {
  props: ["breadcrumb", "showBread", "color"]
}, ho = {
  "aria-label": "You are here:",
  role: "navigation"
}, _o = { class: "breadcrumbs" }, go = ["href"];
function mo(e, o, t, a, n, s) {
  const l = L("router-link");
  return i(), h("nav", ho, [
    d("ul", _o, [
      (i(!0), h(F, null, R(t.breadcrumb, (r) => (i(), h("li", {
        class: $({ onviewportnotranslate: t.showBread }),
        key: r.ID
      }, [
        r.route == null ? (i(), h("a", {
          key: 0,
          style: T({ color: t.color }),
          href: r?.href
        }, p(r.text), 13, go)) : B("", !0),
        r.route != null ? (i(), se(l, {
          key: 1,
          style: T({ color: t.color }),
          to: `${r.route.to}`
        }, {
          default: ae(() => [
            W(p(r.text), 1)
          ]),
          _: 2
        }, 1032, ["style", "to"])) : B("", !0)
      ], 2))), 128))
    ])
  ]);
}
const mn = /* @__PURE__ */ A(uo, [["render", mo], ["__scopeId", "data-v-e0490c58"]]);
const De = {
  name: "TBotaoIcon",
  props: ["backgroundColor", "hoverColor", "borderColor", "textColor"]
}, Ee = () => {
  be((e) => ({
    "122bf975": e.backgroundColor,
    b9984d92: e.borderColor,
    b924ae54: e.textColor,
    f3e89632: e.hoverColor
  }));
}, Me = De.setup;
De.setup = Me ? (e, o) => (Ee(), Me(e, o)) : Ee;
const fo = De, po = { class: "botao_style" };
function vo(e, o, t, a, n, s) {
  return i(), h("div", po, [
    d("p", null, [
      E(e.$slots, "default", {}, void 0, !0)
    ])
  ]);
}
const fn = /* @__PURE__ */ A(fo, [["render", vo], ["__scopeId", "data-v-2dc6829d"]]);
const bo = {
  name: "todaybutton",
  props: ["active", "label", "customStyles"]
};
function yo(e, o, t, a, n, s) {
  return i(), h("div", {
    class: $(["todaybtn", { active: t.active }]),
    style: T(t.customStyles)
  }, p(t.label), 7);
}
const Co = /* @__PURE__ */ A(bo, [["render", yo], ["__scopeId", "data-v-ddc0ec2e"]]);
const So = {
  name: "Chevnext",
  props: {
    color: {
      type: String,
      default: "#000000"
    },
    hovercolor: {
      type: String,
      default: "#000000"
    },
    hoverWithCircle: {
      type: Boolean,
      default: !1
    }
  },
  data: function() {
    return {
      hover: !1
    };
  },
  computed: {
    chevStyles() {
      const { color: e, hover: o, hoverWithCircle: t, hovercolor: a } = this;
      let n = e;
      return o && (n = t ? "#2650e7" : a), {
        color: n,
        background: o && t ? a : "transparent"
      };
    }
  }
};
function ko(e, o, t, a, n, s) {
  return i(), h("i", {
    "data-icon-name": "ChevronRight",
    "aria-hidden": "true",
    class: "ms-Icon ms-Icon--ChevronRightMed",
    onMouseover: o[0] || (o[0] = (l) => e.hover = !0),
    onMouseout: o[1] || (o[1] = (l) => e.hover = !1),
    style: T(s.chevStyles)
  }, null, 36);
}
const Io = /* @__PURE__ */ A(So, [["render", ko], ["__scopeId", "data-v-3b088a75"]]);
const wo = {
  name: "Chevprevious",
  props: {
    color: {
      type: String,
      default: "#000000"
    },
    hovercolor: {
      type: String,
      default: "#000000"
    },
    hoverWithCircle: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      hover: !1
    };
  },
  computed: {
    chevStyles() {
      const { color: e, hover: o, hoverWithCircle: t, hovercolor: a } = this;
      let n = e;
      return o && (n = t ? "#2650e7" : a), {
        color: n,
        background: o && t ? a : "transparent"
      };
    }
  }
};
function Do(e, o, t, a, n, s) {
  return i(), h("i", {
    "data-icon-name": "ChevronRight",
    onMouseover: o[0] || (o[0] = (l) => n.hover = !0),
    onMouseout: o[1] || (o[1] = (l) => n.hover = !1),
    style: T(s.chevStyles),
    "aria-hidden": "true",
    class: "ms-Icon ms-Icon--ChevronLeftMed"
  }, null, 36);
}
const xo = /* @__PURE__ */ A(wo, [["render", Do], ["__scopeId", "data-v-06308b34"]]);
const Ao = {
  name: "datesnavigation",
  props: ["gweek", "monthNavigation", "lang"],
  emits: ["setWeek", "weekviewclicked"],
  components: {
    TodayButton: Co,
    Chevnext: Io,
    Chevprevious: xo
  },
  setup(e, { emit: o }) {
    let t = new Date(), a = t.getDate() - t.getDay() + 1, n = a + 6, s = new Date(t.getFullYear(), t.getMonth(), a), l = new Date(t.getFullYear(), t.getMonth(), n);
    const r = P({
      start: s,
      end: l
    });
    ge(() => e.gweek, (_) => {
      _.start != r.value.start && (r.value = _);
    });
    const v = (_, k = !1) => {
      const j = String(_.getDate()).padStart(2, "0"), oe = _.getMonth(), le = [
        "jan.",
        "fev.",
        "mar.",
        "abr.",
        "mai.",
        "jun.",
        "jul.",
        "ago.",
        "set.",
        "out.",
        "nov.",
        "dez."
      ], de = [
        "jan.",
        "feb.",
        "mar.",
        "apr.",
        "may",
        "jun.",
        "jul.",
        "aug.",
        "sep.",
        "oct.",
        "nov.",
        "dec."
      ];
      let g = e.lang == "pt" ? le[oe] : de[oe];
      if (k) {
        const D = _.getFullYear();
        return `${j} ${g} ${D}`;
      } else
        return `${j} ${g}`;
    }, m = () => {
      const _ = r.value.start.getDate() === 1, k = new Date(r.value.end.getTime());
      k.setDate(k.getDate() + 1);
      const j = r.value.end.getMonth() !== k.getMonth(), oe = r.value.start.getFullYear() === r.value.end.getFullYear() && r.value.start.getMonth() === r.value.end.getMonth();
      return _ && j && oe;
    }, f = x(() => {
      const _ = e.lang == "pt" ? "pt-PT" : "en-EN";
      return new Intl.DateTimeFormat(_, {
        month: "long",
        year: "numeric"
      }).format(r.value.start);
    }), u = x(() => r.value.start == null ? "" : v(r.value.start, !1)), c = x(() => r.value.end == null ? "" : v(r.value.end, !0)), S = x(() => m() ? f.value : `${u.value} - ${c.value}`), C = () => {
      var _ = new Date(), k, j;
      e.monthNavigation ? (k = new Date(_.getFullYear(), _.getMonth(), 1), j = new Date(_.getFullYear(), _.getMonth() + 1, 0)) : (k = new Date(_.setDate(_.getDate() - _.getDay() + 1)), j = new Date(k), j.setDate(j.getDate() + 6)), r.value = {
        start: k,
        end: j
      };
    }, Z = () => {
      let _ = new Date(r.value.start);
      _.setDate(_.getDate() + 7);
      let k = new Date(_);
      k.setDate(k.getDate() + 6), r.value = {
        start: _,
        end: k
      };
    }, Q = () => {
      let _ = new Date(r.value.start);
      _.setDate(_.getDate() - 7);
      let k = new Date(_);
      k.setDate(k.getDate() + 6), r.value = {
        start: _,
        end: k
      };
    }, U = () => {
      let _ = new Date(r.value.start);
      _.setMonth(_.getMonth() + 1), _.setDate(1);
      let k = new Date(_);
      k.setMonth(k.getMonth() + 1), k.setDate(0), r.value = {
        start: _,
        end: k
      };
    }, J = () => {
      let _ = new Date(r.value.start);
      _.setMonth(_.getMonth() - 1), _.setDate(1);
      let k = new Date(_);
      k.setMonth(k.getMonth() + 1), k.setDate(0), r.value = {
        start: _,
        end: k
      };
    }, ne = () => {
      C(), o("setWeek", r.value);
    }, he = () => {
      e.monthNavigation ? J() : Q(), o("setWeek", r.value);
    }, O = () => {
      e.monthNavigation ? U() : Z(), o("setWeek", r.value);
    }, b = () => {
      o("weekviewclicked");
    }, w = x(() => e.lang == "en" ? "Today" : "Hoje");
    return {
      formattedDate: S,
      goToToday: ne,
      previousClicked: he,
      nextClicked: O,
      weekviewclicked: b,
      btnLabel: w
    };
  }
}, Po = { class: "datesnavigation" }, $o = { class: "btnnavigator" };
function To(e, o, t, a, n, s) {
  const l = L("TodayButton"), r = L("Chevprevious"), v = L("Chevnext");
  return i(), h("div", Po, [
    q(l, {
      label: a.btnLabel,
      onClick: a.goToToday
    }, null, 8, ["label", "onClick"]),
    d("div", $o, [
      q(r, {
        class: "prv",
        onClick: a.previousClicked,
        hoverWithCircle: !0,
        hovercolor: "#f5f3f3",
        color: "#1976d2"
      }, null, 8, ["onClick"]),
      q(v, {
        class: "next",
        onClick: a.nextClicked,
        hoverWithCircle: !0,
        hovercolor: "#f5f3f3",
        color: "#1976d2"
      }, null, 8, ["onClick"])
    ]),
    d("div", {
      class: "weekviewer",
      ref: "weekviewer",
      onClick: o[0] || (o[0] = (...m) => a.weekviewclicked && a.weekviewclicked(...m))
    }, p(a.formattedDate), 513)
  ]);
}
const pn = /* @__PURE__ */ A(Ao, [["render", To], ["__scopeId", "data-v-4b13b9ae"]]);
const Oo = {
  name: "Spinner",
  props: ["text"]
}, Ho = { class: "eight-line-spinner" };
function Fo(e, o, t, a, n, s) {
  return i(), h("div", Ho, [
    (i(), h(F, null, R(8, (l) => d("div", {
      key: l,
      class: $("line line-" + l)
    }, null, 2)), 64)),
    W(" " + p(t.text), 1)
  ]);
}
const Eo = /* @__PURE__ */ A(Oo, [["render", Fo], ["__scopeId", "data-v-4034efe7"]]);
const Mo = {
  name: "SpinLoaderText",
  props: ["text"],
  components: {
    spinLoader: Eo
  }
}, Lo = { class: "wrapperspntxt" };
function Wo(e, o, t, a, n, s) {
  const l = L("spinLoader");
  return i(), h("div", null, [
    d("div", Lo, [
      q(l),
      d("span", null, p(t.text), 1)
    ])
  ]);
}
const vn = /* @__PURE__ */ A(Mo, [["render", Wo], ["__scopeId", "data-v-6fd6db73"]]), Bo = [
  { header: "#2caeb4", body: "rgba(113, 213, 211, 0.87)" },
  { header: "#7979d2", body: "rgba(160, 160, 229, 0.87)" },
  { header: "#e76050", body: "rgba(231, 120, 114, 0.87)" },
  { header: "#f1b555", body: "rgba(252, 205, 121, 0.87)" },
  { header: "#5a93db", body: "rgba(127, 179, 244, 0.87)" },
  { header: "#ec8529", body: "rgba(247, 164, 109, 0.87)" },
  { header: "#4e342e", body: "rgba(188, 170, 164, 0.87)" },
  { header: "#DB8180", body: "rgba(233, 176, 175, 0.87)" },
  { header: "#698C7D", body: "rgba(174, 194, 185, 0.87)" },
  { header: "#A59F8D", body: "rgba(201, 197, 186, 0.87)" },
  { header: "#9c27b0", body: "rgba(169, 68, 178, 0.87)" },
  { header: "#e91e63", body: "rgba(244, 143, 177, 0.87)" },
  { header: "#673ab7", body: "rgba(144, 101, 181, 0.87)" },
  { header: "#3f51b5", body: "rgba(120, 144, 237, 0.87)" },
  { header: "#009688", body: "rgba(97, 207, 184, 0.87)" },
  { header: "#4caf50", body: "rgba(139, 226, 138, 0.87)" },
  { header: "#ff5722", body: "rgba(255, 151, 120, 0.87)" },
  { header: "#795548", body: "rgba(158, 133, 117, 0.87)" },
  { header: "#607d8b", body: "rgba(140, 158, 173, 0.87)" },
  { header: "#ff9800", body: "rgba(255, 183, 77, 0.87)" },
  { header: "#2196f3", body: "rgba(98, 176, 242, 0.87)" },
  { header: "#9e9e9e", body: "rgba(179, 179, 179, 0.87)" },
  { header: "#ffeb3b", body: "rgba(255, 237, 140, 0.87)" },
  { header: "#cddc39", body: "rgba(186, 212, 83, 0.87)" },
  { header: "#8bc34a", body: "rgba(148, 208, 91, 0.87)" },
  { header: "#ff5722", body: "rgba(255, 151, 120, 0.87)" },
  { header: "#f44336", body: "rgba(248, 91, 76, 0.87)" },
  { header: "#9c27b0", body: "rgba(169, 68, 178, 0.87)" },
  { header: "#3f51b5", body: "rgba(120, 144, 237, 0.87)" },
  { header: "#4caf50", body: "rgba(139, 226, 138, 0.87)" }
];
process.env.NODE_ENV !== "production" && Object.freeze({});
process.env.NODE_ENV !== "production" && Object.freeze([]);
const ue = Array.isArray;
const No = {
  name: "iconAvaliacao",
  props: ["color"],
  methods: {
    getColor() {
      return {
        fill: this?.color ?? "#FFF"
      };
    }
  }
}, Ro = {
  id: "Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 60 60"
};
function Vo(e, o, t, a, n, s) {
  return i(), h("svg", Ro, [
    d("path", {
      style: T(s.getColor()),
      class: "cls-1",
      d: "M23.3,7.31h21.43c2.96,0,5.36,2.54,5.36,5.67v28.37c0,3.13-2.4,5.67-5.36,5.67,0,3.13-2.4,5.67-5.36,5.67H17.95c-2.96,0-5.36-2.54-5.36-5.67h2.68c0,1.57,1.2,2.84,2.68,2.84h21.43c1.48,0,2.68-1.27,2.68-2.84V18.65c0-1.57-1.2-2.84-2.68-2.84H17.95c-1.48,0-2.68,1.27-2.68,2.84h-2.68c0-3.13,2.4-5.67,5.36-5.67h21.43c2.96,0,5.36,2.54,5.36,5.67v25.53c1.48,0,2.68-1.27,2.68-2.84V12.98c0-1.57-1.2-2.84-2.68-2.84H23.3c-1.48,0-2.68,1.27-2.68,2.84h-2.68c0-3.13,2.4-5.67,5.36-5.67Z"
    }, null, 4),
    d("path", {
      style: T(s.getColor()),
      class: "cls-1",
      d: "M12.59,24.33v-1.42c0-.78,.6-1.42,1.34-1.42s1.34,.64,1.34,1.42v1.42h1.34c.74,0,1.34,.64,1.34,1.42s-.6,1.42-1.34,1.42h-5.36c-.74,0-1.34-.64-1.34-1.42s.6-1.42,1.34-1.42h1.34Zm0,8.51v-1.42c0-.78,.6-1.42,1.34-1.42s1.34,.64,1.34,1.42v1.42h1.34c.74,0,1.34,.64,1.34,1.42s-.6,1.42-1.34,1.42h-5.36c-.74,0-1.34-.64-1.34-1.42s.6-1.42,1.34-1.42h1.34Zm0,7.09v1.42h-1.34c-.74,0-1.34,.64-1.34,1.42s.6,1.42,1.34,1.42h5.36c.74,0,1.34-.64,1.34-1.42s-.6-1.42-1.34-1.42h-1.34v-1.42c0-.78-.6-1.42-1.34-1.42s-1.34,.64-1.34,1.42Z"
    }, null, 4)
  ]);
}
const Ko = /* @__PURE__ */ A(No, [["render", Vo], ["__scopeId", "data-v-4dd48676"]]);
const jo = {
  name: "eventItem",
  props: [
    "colorbackground",
    "colorseparador",
    "disciplina",
    "sala",
    "professor",
    "tipo",
    "horaInicio",
    "horaFim",
    "ano",
    "turma",
    "lang",
    "curso"
  ],
  components: {
    iconAvaliacao: Ko
  },
  setup(e) {
    const o = x(() => ({
      "border-left": `3px solid ${e.colorseparador}`
    })), t = x(() => e.horaInicio.slice(0, 5)), a = x(() => e.horaFim.slice(0, 5)), n = x(() => e.lang == "en" ? "Professor" : "Docente"), s = x(() => e.lang == "en" ? "Assessments" : "Avaliac\xE3o");
    return {
      eventStyle: o,
      startHour: t,
      endHour: a,
      getDocenteLabel: (v) => ue(v) ? v.join(", ") : v,
      formatSala: (v) => ue(v) ? v.join(", ") : v,
      labelDocente: n,
      labelAvaliacao: s
    };
  }
}, zo = { class: "event-item-hours" }, Go = { class: "event-item-info" }, qo = {
  key: 0,
  class: "disciplina"
}, Xo = { class: "minfo" }, Yo = { class: "moreinfo" }, Uo = { class: "moreinfo" }, Zo = { class: "moreinfo" };
function Qo(e, o, t, a, n, s) {
  const l = L("iconAvaliacao");
  return i(), h("div", {
    class: "event-item",
    style: T(a.eventStyle)
  }, [
    d("div", zo, [
      q(l, { color: t.colorseparador }, null, 8, ["color"])
    ]),
    d("div", Go, [
      t.curso != null ? (i(), h("div", qo, p(t.curso), 1)) : B("", !0),
      d("div", {
        class: $({
          disciplina: t.curso == null,
          minfo: t.curso != null
        })
      }, p(a.labelAvaliacao) + " - " + p(t.tipo) + " - " + p(t.disciplina), 3),
      d("div", Xo, [
        d("div", Yo, p(a.startHour) + " - " + p(a.endHour), 1),
        d("div", Uo, p(a.formatSala(t.sala)), 1),
        d("div", Zo, p(a.labelDocente) + ": " + p(a.getDocenteLabel(t.professor)), 1)
      ])
    ])
  ], 4);
}
const Jo = /* @__PURE__ */ A(jo, [["render", Qo], ["__scopeId", "data-v-0ad31cb9"]]);
const ea = {
  name: "daywrapper",
  props: ["sortedKeys", "inx"]
}, ta = ["cday"];
function oa(e, o, t, a, n, s) {
  return i(), h("div", {
    cday: t.sortedKeys[t.inx],
    ref: `currentDay${t.sortedKeys[t.inx]}`,
    class: "daywrapper"
  }, [
    E(e.$slots, "default", {}, void 0, !0)
  ], 8, ta);
}
const aa = /* @__PURE__ */ A(ea, [["render", oa], ["__scopeId", "data-v-2e200752"]]);
const sa = {
  name: "DayHeader"
};
function na(e, o, t, a, n, s) {
  return i(), h("h2", null, [
    E(e.$slots, "default", {}, void 0, !0)
  ]);
}
const ra = /* @__PURE__ */ A(sa, [["render", na], ["__scopeId", "data-v-e02a17b6"]]);
const ia = {
  name: "AvalList",
  props: ["week", "aulas", "lang", "showCurso"],
  components: {
    EventItem: Jo,
    dayHeader: ra,
    daywrapper: aa
  },
  setup(e) {
    const o = x(() => {
      const f = [...new Set(e.aulas.map((c) => c.cadeira == "Feriados" ? "Feriado" : c.cadeira))], u = {};
      return f.map((c, S) => {
        u[c] = Bo[S];
      }), u;
    }), t = e.lang == "pt" ? "pt-PT" : "en-uk", a = new Intl.DateTimeFormat(t, { weekday: "long" }), n = new Intl.DateTimeFormat(t, { day: "2-digit" }), s = new Intl.DateTimeFormat(t, { month: "long" }), l = (f) => `${n.format(f)} ${s.format(f)} - ${a.format(f)}`, r = x(() => e.aulas.map((f) => {
      if (f.Data != null)
        return l(new Date(f.Data));
    }).filter((f, u, c) => c.indexOf(f) === u && f != null)), v = x(() => (e.aulas.sort((u, c) => {
      let S = new Date(u.Data) - new Date(c.Data);
      return S === 0 ? u.horaInicio.localeCompare(c.horaInicio) : S;
    }), e.aulas.reduce((u, c) => {
      let S;
      return c.Data != null && (S = l(new Date(c.Data)), (u[S] = u[S] || []).push(c)), u;
    }, {}))), m = x(() => e.lang == "pt" ? "N\xE3o existem avalia\xE7\xF5es neste m\xEAs" : "There are no assessments available for this month");
    return {
      eventColors: o,
      sortedKeys: r,
      sortedCalendario: v,
      semavaliacao: m
    };
  }
}, la = (e) => (ee("data-v-2b983d32"), e = e(), te(), e), da = {
  key: 0,
  class: "event-list-container",
  ref: "eventListContainer"
}, ca = {
  class: "eventlist",
  ref: "evlist"
}, ua = { key: 0 }, ha = /* @__PURE__ */ la(() => /* @__PURE__ */ d("i", {
  class: "ms-Icon ms-Icon--Warning",
  title: "Warning",
  "aria-hidden": "true"
}, null, -1));
function _a(e, o, t, a, n, s) {
  const l = L("dayHeader"), r = L("EventItem"), v = L("daywrapper");
  return t.aulas != null ? (i(), h("div", da, [
    d("div", ca, [
      (i(!0), h(F, null, R(a.sortedKeys, (m, f) => (i(), se(v, {
        sortedKeys: a.sortedKeys,
        inx: f,
        key: m
      }, {
        default: ae(() => [
          q(l, null, {
            default: ae(() => [
              W(p(m), 1)
            ]),
            _: 2
          }, 1024),
          E(e.$slots, "event", {
            sortedCalendario: a.sortedCalendario,
            key: m,
            lang: t.lang,
            eventColors: a.eventColors
          }, () => [
            (i(!0), h(F, null, R(a.sortedCalendario[m], (u) => (i(), se(r, {
              key: u.id,
              lang: t.lang,
              class: "eventItem",
              colorbackground: a.eventColors[u.cadeira].body,
              colorseparador: a.eventColors[u.cadeira].header,
              horaInicio: u.horaInicio,
              horaFim: u.horaFim,
              disciplina: u.cadeira,
              tipo: u.tipo,
              sala: u.sala_desc,
              ano: u.ano,
              turma: u.turma,
              curso: t.showCurso ? u?.curso : null,
              professor: u.docente
            }, null, 8, ["lang", "colorbackground", "colorseparador", "horaInicio", "horaFim", "disciplina", "tipo", "sala", "ano", "turma", "curso", "professor"]))), 128))
          ], !0)
        ]),
        _: 2
      }, 1032, ["sortedKeys", "inx"]))), 128)),
      Object.keys(a.sortedCalendario).length === 0 ? (i(), h("p", ua, [
        ha,
        W(" " + p(a.semavaliacao), 1)
      ])) : B("", !0)
    ], 512)
  ], 512)) : B("", !0);
}
const bn = /* @__PURE__ */ A(ia, [["render", _a], ["__scopeId", "data-v-2b983d32"]]), ga = [
  { header: "#2caeb4", body: "rgba(113, 213, 211, 0.87)" },
  { header: "#7979d2", body: "rgba(160, 160, 229, 0.87)" },
  { header: "#e76050", body: "rgba(231, 120, 114, 0.87)" },
  { header: "#f1b555", body: "rgba(252, 205, 121, 0.87)" },
  { header: "#5a93db", body: "rgba(127, 179, 244, 0.87)" },
  { header: "#ec8529", body: "rgba(247, 164, 109, 0.87)" },
  { header: "#4e342e", body: "rgba(188, 170, 164, 0.87)" },
  { header: "#DB8180", body: "rgba(233, 176, 175, 0.87)" },
  { header: "#698C7D", body: "rgba(174, 194, 185, 0.87)" },
  { header: "#A59F8D", body: "rgba(201, 197, 186, 0.87)" },
  { header: "#9c27b0", body: "rgba(169, 68, 178, 0.87)" },
  { header: "#e91e63", body: "rgba(244, 143, 177, 0.87)" },
  { header: "#673ab7", body: "rgba(144, 101, 181, 0.87)" },
  { header: "#3f51b5", body: "rgba(120, 144, 237, 0.87)" },
  { header: "#009688", body: "rgba(97, 207, 184, 0.87)" },
  { header: "#4caf50", body: "rgba(139, 226, 138, 0.87)" },
  { header: "#ff5722", body: "rgba(255, 151, 120, 0.87)" },
  { header: "#795548", body: "rgba(158, 133, 117, 0.87)" },
  { header: "#607d8b", body: "rgba(140, 158, 173, 0.87)" },
  { header: "#ff9800", body: "rgba(255, 183, 77, 0.87)" },
  { header: "#2196f3", body: "rgba(98, 176, 242, 0.87)" },
  { header: "#9e9e9e", body: "rgba(179, 179, 179, 0.87)" },
  { header: "#ffeb3b", body: "rgba(255, 237, 140, 0.87)" },
  { header: "#cddc39", body: "rgba(186, 212, 83, 0.87)" },
  { header: "#8bc34a", body: "rgba(148, 208, 91, 0.87)" },
  { header: "#ff5722", body: "rgba(255, 151, 120, 0.87)" },
  { header: "#f44336", body: "rgba(248, 91, 76, 0.87)" },
  { header: "#9c27b0", body: "rgba(169, 68, 178, 0.87)" },
  { header: "#3f51b5", body: "rgba(120, 144, 237, 0.87)" },
  { header: "#4caf50", body: "rgba(139, 226, 138, 0.87)" }
];
const ma = {
  name: "iconAvaliacao",
  props: ["color"],
  methods: {
    getColor() {
      return {
        fill: this?.color ?? "#FFF"
      };
    }
  }
}, fa = {
  id: "Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 60 60"
};
function pa(e, o, t, a, n, s) {
  return i(), h("svg", fa, [
    d("path", {
      style: T(s.getColor()),
      class: "cls-1",
      d: "M23.3,7.31h21.43c2.96,0,5.36,2.54,5.36,5.67v28.37c0,3.13-2.4,5.67-5.36,5.67,0,3.13-2.4,5.67-5.36,5.67H17.95c-2.96,0-5.36-2.54-5.36-5.67h2.68c0,1.57,1.2,2.84,2.68,2.84h21.43c1.48,0,2.68-1.27,2.68-2.84V18.65c0-1.57-1.2-2.84-2.68-2.84H17.95c-1.48,0-2.68,1.27-2.68,2.84h-2.68c0-3.13,2.4-5.67,5.36-5.67h21.43c2.96,0,5.36,2.54,5.36,5.67v25.53c1.48,0,2.68-1.27,2.68-2.84V12.98c0-1.57-1.2-2.84-2.68-2.84H23.3c-1.48,0-2.68,1.27-2.68,2.84h-2.68c0-3.13,2.4-5.67,5.36-5.67Z"
    }, null, 4),
    d("path", {
      style: T(s.getColor()),
      class: "cls-1",
      d: "M12.59,24.33v-1.42c0-.78,.6-1.42,1.34-1.42s1.34,.64,1.34,1.42v1.42h1.34c.74,0,1.34,.64,1.34,1.42s-.6,1.42-1.34,1.42h-5.36c-.74,0-1.34-.64-1.34-1.42s.6-1.42,1.34-1.42h1.34Zm0,8.51v-1.42c0-.78,.6-1.42,1.34-1.42s1.34,.64,1.34,1.42v1.42h1.34c.74,0,1.34,.64,1.34,1.42s-.6,1.42-1.34,1.42h-5.36c-.74,0-1.34-.64-1.34-1.42s.6-1.42,1.34-1.42h1.34Zm0,7.09v1.42h-1.34c-.74,0-1.34,.64-1.34,1.42s.6,1.42,1.34,1.42h5.36c.74,0,1.34-.64,1.34-1.42s-.6-1.42-1.34-1.42h-1.34v-1.42c0-.78-.6-1.42-1.34-1.42s-1.34,.64-1.34,1.42Z"
    }, null, 4)
  ]);
}
const va = /* @__PURE__ */ A(ma, [["render", pa], ["__scopeId", "data-v-e6b86723"]]);
const ba = {
  name: "eventItem",
  props: [
    "colorbackground",
    "colorseparador",
    "disciplina",
    "sala",
    "professor",
    "tipo",
    "horaInicio",
    "horaFim",
    "ano",
    "turma",
    "lang",
    "curso",
    "titulo",
    "subtitulo"
  ],
  components: {
    iconAvaliacao: va
  },
  setup(e) {
    const o = x(() => e.curso == null ? "disciplina" : "minfo"), t = x(() => ({
      "border-left": `3px solid ${e.colorseparador}`
    })), a = x(() => e.horaInicio.slice(0, 5)), n = x(() => e.horaFim.slice(0, 5)), s = x(() => e.lang == "en" ? "Professor" : "Docente"), l = x(() => e.lang == "en" ? "Assessments" : "Avaliac\xE3o"), r = (f) => ue(f) ? f.join(", ") : f, v = (f) => ue(f) ? f.join(", ") : f, m = x(() => e.curso?.join(", "));
    return {
      getItemClass: o,
      eventStyle: t,
      startHour: a,
      endHour: n,
      getDocenteLabel: r,
      formatSala: v,
      labelDocente: s,
      labelAvaliacao: l,
      cursosLabel: m
    };
  }
}, ya = { class: "event-item-hours" }, Ca = { class: "event-item-info" }, Sa = { class: "disciplina" }, ka = { class: "moreinfo" }, Ia = { class: "moreinfo" }, wa = { class: "moreinfo" };
function Da(e, o, t, a, n, s) {
  const l = L("iconAvaliacao");
  return i(), h("div", {
    class: "event-item",
    style: T(a.eventStyle)
  }, [
    d("div", ya, [
      E(e.$slots, "icon", {}, () => [
        q(l, { color: t.colorseparador }, null, 8, ["color"])
      ], !0)
    ]),
    d("div", Ca, [
      d("div", Sa, [
        E(e.$slots, "titulo", {}, () => [
          W(p(a.cursosLabel), 1)
        ], !0)
      ]),
      d("div", {
        class: $(a.getItemClass)
      }, [
        E(e.$slots, "subtitulolivre", {}, void 0, !0)
      ], 2),
      d("div", {
        class: $(["minfo", { morepadding: t.curso != null }])
      }, [
        E(e.$slots, "moreinfo", {}, () => [
          d("div", ka, p(a.startHour) + " - " + p(a.endHour), 1),
          d("div", Ia, p(a.formatSala(t.sala)), 1),
          d("div", wa, p(a.labelDocente) + ": " + p(a.getDocenteLabel(t.professor)), 1)
        ], !0)
      ], 2)
    ])
  ], 4);
}
const xa = /* @__PURE__ */ A(ba, [["render", Da], ["__scopeId", "data-v-cf47b393"]]);
const Aa = {
  name: "daywrapper",
  props: ["sortedKeys", "inx"]
}, Pa = ["cday"];
function $a(e, o, t, a, n, s) {
  return i(), h("div", {
    cday: t.sortedKeys[t.inx],
    ref: `currentDay${t.sortedKeys[t.inx]}`,
    class: "daywrapper"
  }, [
    E(e.$slots, "default", {}, void 0, !0)
  ], 8, Pa);
}
const Ta = /* @__PURE__ */ A(Aa, [["render", $a], ["__scopeId", "data-v-09a22d90"]]);
const Oa = {
  name: "DayHeader"
};
function Ha(e, o, t, a, n, s) {
  return i(), h("h2", null, [
    E(e.$slots, "default", {}, void 0, !0)
  ]);
}
const Fa = /* @__PURE__ */ A(Oa, [["render", Ha], ["__scopeId", "data-v-84257383"]]);
const Ea = {
  name: "AvalList",
  props: ["week", "aulas", "lang", "showCurso"],
  components: {
    EventItem: xa,
    dayHeader: Fa,
    daywrapper: Ta
  },
  setup(e) {
    const o = x(() => {
      const f = [...new Set(e.aulas.map((c) => c.cadeira == "Feriados" ? "Feriado" : c.cadeira))], u = {};
      return f.map((c, S) => {
        u[c] = ga[S];
      }), u;
    }), t = e.lang == "pt" ? "pt-PT" : "en-uk", a = new Intl.DateTimeFormat(t, { weekday: "long" }), n = new Intl.DateTimeFormat(t, { day: "2-digit" }), s = new Intl.DateTimeFormat(t, { month: "long" }), l = (f) => `${n.format(f)} ${s.format(f)} - ${a.format(f)}`, r = x(() => e.aulas.map((f) => {
      if (f.Data != null)
        return l(new Date(f.Data));
    }).filter((f, u, c) => c.indexOf(f) === u && f != null)), v = x(() => {
      e.aulas.sort((u, c) => {
        let S = new Date(u.Data) - new Date(c.Data);
        return S === 0 ? u.horaInicio.localeCompare(c.horaInicio) : S;
      });
      let f = e.aulas.reduce((u, c) => {
        let S;
        return c.Data != null && (S = l(new Date(c.Data)), (u[S] = u[S] || []).push(c)), u;
      }, {});
      return console.log(f), f;
    }), m = x(() => e.lang == "pt" ? "N\xE3o existem avalia\xE7\xF5es neste m\xEAs" : "There are no assessments available for this month");
    return {
      eventColors: o,
      sortedKeys: r,
      sortedCalendario: v,
      semavaliacao: m
    };
  }
}, Ma = (e) => (ee("data-v-ac3140ff"), e = e(), te(), e), La = {
  key: 0,
  class: "event-list-container",
  ref: "eventListContainer"
}, Wa = {
  class: "eventlist",
  ref: "evlist"
}, Ba = { key: 0 }, Na = /* @__PURE__ */ Ma(() => /* @__PURE__ */ d("i", {
  class: "ms-Icon ms-Icon--Warning",
  title: "Warning",
  "aria-hidden": "true"
}, null, -1));
function Ra(e, o, t, a, n, s) {
  const l = L("dayHeader"), r = L("EventItem"), v = L("daywrapper");
  return t.aulas != null ? (i(), h("div", La, [
    d("div", Wa, [
      (i(!0), h(F, null, R(a.sortedKeys, (m, f) => (i(), se(v, {
        sortedKeys: a.sortedKeys,
        inx: f,
        key: m
      }, {
        default: ae(() => [
          q(l, null, {
            default: ae(() => [
              W(p(m), 1)
            ]),
            _: 2
          }, 1024),
          E(e.$slots, "event", {
            sortedCalendario: a.sortedCalendario,
            key: m,
            lang: t.lang,
            eventColors: a.eventColors
          }, () => [
            (i(!0), h(F, null, R(a.sortedCalendario[m], (u) => (i(), se(r, {
              key: u.id,
              lang: t.lang,
              class: "eventItem",
              colorbackground: a.eventColors[u.cadeira].body,
              colorseparador: a.eventColors[u.cadeira].header,
              horaInicio: u.horaInicio,
              horaFim: u.horaFim,
              disciplina: u.cadeira,
              tipo: u.tipo,
              sala: u.sala_desc,
              ano: u.ano,
              turma: u.turma,
              curso: t.showCurso ? u?.curso : null,
              professor: u.docente
            }, null, 8, ["lang", "colorbackground", "colorseparador", "horaInicio", "horaFim", "disciplina", "tipo", "sala", "ano", "turma", "curso", "professor"]))), 128))
          ], !0)
        ]),
        _: 2
      }, 1032, ["sortedKeys", "inx"]))), 128)),
      E(e.$slots, "noresults", {}, () => [
        Object.keys(a.sortedCalendario).length === 0 ? (i(), h("p", Ba, [
          Na,
          W(),
          E(e.$slots, "noresultsmsg", {}, () => [
            W(p(a.semavaliacao), 1)
          ], !0)
        ])) : B("", !0)
      ], !0)
    ], 512)
  ], 512)) : B("", !0);
}
const yn = /* @__PURE__ */ A(Ea, [["render", Ra], ["__scopeId", "data-v-ac3140ff"]]);
const Va = {
  name: "itemHover",
  props: ["professor", "lang"],
  setup(e) {
    return {
      label: x(() => e.lang == "en" ? "Professor" : "Docente")
    };
  }
}, Ka = { class: "itemhover" }, ja = { class: "label" }, za = { class: "plabel" };
function Ga(e, o, t, a, n, s) {
  return i(), h("div", Ka, [
    d("p", ja, p(a.label) + ":", 1),
    d("p", za, p(t.professor), 1)
  ]);
}
const qa = /* @__PURE__ */ A(Va, [["render", Ga], ["__scopeId", "data-v-4a21c001"]]);
const xe = {
  name: "CalendarItem",
  components: {
    itemHover: qa
  },
  props: [
    "colorheader",
    "colorbackground",
    "disciplina",
    "sala",
    "professor",
    "tipo",
    "horaInicio",
    "horaFim",
    "columnstart",
    "aulaHeight",
    "smallfont",
    "piso",
    "lang",
    "showlabel",
    "truncate",
    "duracao"
  ],
  setup(e) {
    const o = x(() => e.lang == "en" ? "Floor" : "Piso"), t = x(() => ({
      "background-color": e.colorbackground,
      height: e.aulaHeight,
      "grid-column": e.columnstart,
      "grid-column-end": "span 1"
    })), a = P(""), n = P(""), s = P(null), l = P(null), r = (m, f) => {
      const u = document.createElement("div");
      document.body.appendChild(u), u.style.position = "absolute", u.style.visibility = "hidden", u.style.font = '15px "Montserrat Light"', u.style.width = `${f}px`, u.style.paddingLeft = "15px", u.style.paddingRight = "15px", u.style.paddingTop = "14px", u.style.lineHeight = "1.2", u.textContent = m;
      const c = u.clientHeight;
      return document.body.removeChild(u), c;
    }, v = () => {
      const m = l.value ? l.value.clientHeight : 0, f = s.value.clientWidth - 30, u = parseFloat(e.aulaHeight) - m;
      let c = r(e.disciplina, f), S = "";
      for (const C of e.disciplina)
        if (S += C, c = r(S, f), c > u) {
          S += "...";
          break;
        }
      n.value = S;
    };
    return ge(() => e.disciplina, v), ge(() => e.aulaHeight, v), ye(() => {
      v(), window.addEventListener("resize", v);
    }), Qe(() => {
      window.removeEventListener("resize", v);
    }), {
      truncatedTitle: a,
      pisolabel: o,
      cellStyle: t,
      header: l,
      info: s,
      truncatedText: n
    };
  }
}, Le = () => {
  be((e) => ({
    fefac38a: e.colorbackground
  }));
}, We = xe.setup;
xe.setup = We ? (e, o) => (Le(), We(e, o)) : Le;
const Xa = xe, Ya = {
  class: "info",
  ref: "info"
}, Ua = {
  key: 0,
  class: "tpsala"
};
function Za(e, o, t, a, n, s) {
  const l = L("itemHover");
  return i(), h("div", {
    class: $(["aula", { smallfont: t.smallfont }]),
    style: T(a.cellStyle)
  }, [
    d("div", {
      class: "header",
      ref: "header",
      style: T({ "background-color": t.colorheader })
    }, [
      d("p", null, p(t.horaInicio) + "-" + p(t.horaFim), 1)
    ], 4),
    d("div", Ya, [
      d("p", null, [
        E(e.$slots, "primary", { truncatedText: a.truncatedText }, () => [
          W(p(a.truncatedText), 1)
        ], !0)
      ]),
      t.truncate ? B("", !0) : (i(), h("p", Ua, [
        E(e.$slots, "secondary", {
          tipo: t.tipo,
          sala: t.sala,
          pisolabel: a.pisolabel,
          piso: t.piso
        }, () => [
          t.tipo.length > 0 ? (i(), h(F, { key: 0 }, [
            W("[" + p(t.tipo) + "]", 1)
          ], 64)) : B("", !0),
          W(" " + p(t.sala) + " ", 1),
          t.piso != null ? (i(), h(F, { key: 1 }, [
            W("- " + p(a.pisolabel) + " " + p(t.piso), 1)
          ], 64)) : B("", !0)
        ], !0)
      ]))
    ], 512),
    t.professor.length > 0 && t.showlabel != !1 ? (i(), se(l, {
      key: 0,
      class: "itemHover",
      professor: t.professor,
      lang: t.lang
    }, null, 8, ["professor", "lang"])) : B("", !0)
  ], 6);
}
const Qa = /* @__PURE__ */ A(Xa, [["render", Za], ["__scopeId", "data-v-c598e235"]]), Ja = {
  beforeMount: (e, o) => {
    let t = !1;
    const a = (n) => {
      !(e === n.target || e.contains(n.target)) && !t && o.value(), t = !1;
    };
    e.addEventListener("mousedown", () => {
      t = !0;
    }), document.addEventListener("mouseup", a), e.__vueClickOutside__ = a;
  },
  unmounted: (e) => {
    document.removeEventListener("mouseup", e.__vueClickOutside__), delete e.__vueClickOutside__;
  }
};
const es = {
  props: {
    isVisible: Boolean,
    position: {
      type: String,
      default: "right",
      validator: (e) => ["left", "right", "top", "bottom"].includes(e)
    },
    numberOfCells: Number,
    itemkey: String
  },
  setup(e, { emit: o }) {
    const t = P(null);
    let a = P({});
    const n = () => {
      const m = t.value.parentNode, f = t.value.offsetWidth, u = m.offsetWidth, c = f / 2, S = u / 2;
      return -c + S;
    }, s = () => {
      if (t.value && (e.position == "bottom" || e.position == "top")) {
        const m = n();
        a.value.left = `${m}px`, e.position == "bottom" ? a.value.top = `${e.numberOfCells * 100 + 50}%` : a.value.top = `-${e.numberOfCells * 100 + 135}%`;
      }
      t.value && (e.position == "left" || e.position == "right") && (a.value = {});
    };
    return ge(() => e.isVisible, (m) => {
      m && ke(() => {
        s();
      });
    }), {
      popup: t,
      popupStyles: a,
      closePopup: () => {
        e.isVisible && o("close", e.itemkey);
      },
      clickOutside: () => {
        e.isVisible && o("outside", e.itemkey);
      },
      onAfterLeave: () => {
        o("removed");
      }
    };
  },
  directives: {
    clickOutside: Ja
  }
}, ze = (e) => (ee("data-v-48cb2f88"), e = e(), te(), e), ts = /* @__PURE__ */ ze(() => /* @__PURE__ */ d("div", { class: "popuparrow" }, null, -1)), os = /* @__PURE__ */ ze(() => /* @__PURE__ */ d("i", { class: "ms-Icon ms-Icon--ChromeClose" }, null, -1)), as = [
  os
];
function ss(e, o, t, a, n, s) {
  const l = me("clickOutside");
  return i(), se(Ve, {
    name: "expand",
    onAfterLeave: a.onAfterLeave
  }, {
    default: ae(() => [
      ie((i(), h("div", {
        ref: "popup",
        class: $(["popup", t.position]),
        style: T(a.popupStyles)
      }, [
        d("div", {
          class: "popup-content",
          onClick: o[0] || (o[0] = Se(() => {
          }, ["stop"]))
        }, [
          E(e.$slots, "default", {}, void 0, !0)
        ]),
        ts,
        d("div", {
          class: "closebtn",
          onClick: o[1] || (o[1] = (...r) => a.closePopup && a.closePopup(...r))
        }, as)
      ], 6)), [
        [ve, t.isVisible],
        [l, a.clickOutside]
      ])
    ]),
    _: 3
  }, 8, ["onAfterLeave"]);
}
const ns = /* @__PURE__ */ A(es, [["render", ss], ["__scopeId", "data-v-48cb2f88"]]);
const rs = {
  name: "PopupContent",
  props: [
    "horaInicio",
    "horaFim",
    "cadeira",
    "sala",
    "docente",
    "color",
    "piso",
    "lang",
    "tipo"
  ],
  setup(e) {
    const o = x(() => e.lang == "pt" ? "Docente" : "Professor"), t = x(() => e.lang == "pt" ? "Piso" : "Floor");
    return {
      docentelabel: o,
      pisolabel: t
    };
  }
}, is = { class: "pcontent" }, ls = { class: "hour" }, ds = { class: "title" }, cs = { class: "cadeiraname" }, us = { class: "small" }, hs = { class: "small" }, _s = { class: "small" };
function gs(e, o, t, a, n, s) {
  return i(), h("div", is, [
    d("p", ls, p(t.horaInicio) + " - " + p(t.horaFim), 1),
    d("p", ds, [
      d("div", {
        class: "square",
        style: T({
          "background-color": t.color
        })
      }, null, 4),
      d("span", cs, p(t.cadeira), 1)
    ]),
    d("p", us, p(t.tipo), 1),
    d("p", hs, p(t.sala) + " - " + p(a.pisolabel) + " " + p(t.piso), 1),
    d("p", _s, p(a.docentelabel) + ": " + p(t.docente), 1)
  ]);
}
const ms = /* @__PURE__ */ A(rs, [["render", gs], ["__scopeId", "data-v-76b894e0"]]);
const fs = {
  props: ["numero", "texto", "isActive"]
}, ps = { class: "wrp" };
function vs(e, o, t, a, n, s) {
  return i(), h("div", ps, [
    d("p", {
      class: $(["numero", { active: t.isActive }])
    }, p(t.numero), 3),
    d("p", {
      class: $(["texto", { active: t.isActive }])
    }, p(t.texto), 3)
  ]);
}
const bs = /* @__PURE__ */ A(fs, [["render", vs], ["__scopeId", "data-v-c778d040"]]);
const ys = {
  name: "HeaderGrid",
  props: [
    "start",
    "headersize",
    "totalcolumns",
    "numberOfEventsPerDay",
    "lang"
  ],
  components: {
    dayHeader: bs
  },
  data() {
    return {
      numbers: []
    };
  },
  computed: {
    headerColumnsForPrint() {
      let e = ["40px"];
      return Object.entries(this.headersize).forEach(([o, t]) => {
        const a = t / this.totalcolumns * 100;
        t > 0 && e.push(`${a}fr`);
      }), e.join(" ");
    },
    headerColumns() {
      let e = ["70px"];
      return Object.entries(this.headersize).forEach(([o, t]) => {
        const a = t / this.totalcolumns * 100;
        t > 0 && e.push(`${a}fr`);
      }), e.join(" ");
    },
    formatterdayname() {
      const e = this.lang == "pt" ? "pt-PT" : "en-EN";
      return new Intl.DateTimeFormat(e, { weekday: "long" });
    },
    formatter() {
      const e = this.lang == "pt" ? "pt-PT" : "en-EN";
      return new Intl.DateTimeFormat(e, { day: "2-digit" });
    },
    days() {
      this.numbers = [];
      let e = new Date(), o = new Date(this.start.getTime()), t = [];
      for (var a = 0; a < 7; a++)
        this.numbers.push(this.formatter.format(o)), this.isDayBetweenMondayAndFridayOrWeekendWasEvents(a) && t.push({
          label: this.formatterdayname.format(o),
          value: this.getNumberWeekDay(a),
          isToday: this.isToday(o, e)
        }), o.setDate(o.getDate() + 1);
      return t;
    }
  },
  methods: {
    isDayBetweenMondayAndFridayOrWeekendWasEvents(e) {
      return e < 5 || this.numberOfEventsPerDay[this.getNumberWeekDay(e)] > 0;
    },
    isToday(e, o) {
      return e.getFullYear() === o.getFullYear() && e.getMonth() === o.getMonth() && e.getDate() === o.getDate();
    },
    getNumberWeekDay(e) {
      return e < 6 ? e + 2 : 1;
    }
  }
}, Cs = (e) => (ee("data-v-1635b4fb"), e = e(), te(), e), Ss = /* @__PURE__ */ Cs(() => /* @__PURE__ */ d("div", null, null, -1));
function ks(e, o, t, a, n, s) {
  const l = L("dayHeader");
  return i(), h("div", {
    class: "headergrid",
    style: T({
      "grid-template-columns": s.headerColumns,
      "--print-grid-columns": s.headerColumnsForPrint
    })
  }, [
    Ss,
    (i(!0), h(F, null, R(s.days, (r, v) => (i(), se(l, {
      class: $(["dayheaderitem", { first: v == 0 }]),
      isActive: r.isToday,
      texto: r.label,
      key: v,
      numero: n.numbers[v]
    }, null, 8, ["class", "isActive", "texto", "numero"]))), 128))
  ], 4);
}
const Is = /* @__PURE__ */ A(ys, [["render", ks], ["__scopeId", "data-v-1635b4fb"]]);
const ws = {
  name: "HourGrid",
  props: [
    "cellsWithLargerHeight",
    "totalcolumns",
    "hours",
    "showall",
    "calculatedCellHeigth",
    "calculatedSmallCellMultiplier"
  ],
  setup(e) {
    return {};
  },
  methods: {
    getHourHeight(e) {
      const o = this.generateKeysForHour(e);
      var t = this.calculatedCellHeigth;
      return o.forEach((a) => {
        var n = this.getCellMultiplier(a);
        this.isCurrentCellHeigthLargerThanPrevious(this.calculatedCellHeigth, n, t) && (t = this.calculatedCellHeigth * n);
      }), `${t}px`;
    },
    isCurrentCellHeigthLargerThanPrevious(e, o, t) {
      return e * o > t;
    },
    getCellMultiplier(e) {
      return this.cellsWithLargerHeight.has(e) ? this.calculatedSmallCellMultiplier : 1;
    },
    generateKeysForHour(e) {
      let o = e.replace(":", "");
      return [...Array(this.totalcolumns).keys()].map((t) => `${t + 1}${o}`);
    }
  }
}, Ds = { class: "hourgrid" };
function xs(e, o, t, a, n, s) {
  return i(), h("div", Ds, [
    (i(!0), h(F, null, R(t.hours, (l) => (i(), h("p", {
      style: T({ height: s.getHourHeight(l) }),
      key: l
    }, p(l), 5))), 128))
  ]);
}
const As = /* @__PURE__ */ A(ws, [["render", xs], ["__scopeId", "data-v-c3a28956"]]), Ge = 35, Be = 3, Ps = 2.1;
const $s = {
  name: "bodygrid",
  props: ["totalcolumns", "showall", "bodyheight"],
  setup(e) {
    const o = x(() => `70px repeat(auto-fit, minmax(${100 / e.totalcolumns - 2}%, 1fr))`), t = x(() => `40px repeat(auto-fit, minmax(${100 / e.totalcolumns - 2}%, 1fr))`);
    return {
      bodyColumnsgrid: o,
      pringbc: t
    };
  }
};
function Ts(e, o, t, a, n, s) {
  return i(), h("div", {
    style: T({
      "grid-template-columns": a.bodyColumnsgrid,
      "overflow-y": t.showall ? "" : "scroll",
      "max-height": t.bodyheight,
      "--print-grid-columns": a.pringbc
    }),
    class: "bodygrid"
  }, [
    E(e.$slots, "default", {}, void 0, !0)
  ], 4);
}
const Os = /* @__PURE__ */ A($s, [["render", Ts], ["__scopeId", "data-v-7d7f7f27"]]);
function Hs(e) {
  const o = P(null), t = P("right"), a = P(!1);
  let n = null;
  const s = P(null), l = P(null), r = (b) => b === n && a.value, v = (b, w, _, k) => {
    const j = `${w.id}${_}${k.replace(":", "")}`;
    if (w.Tipo != "feriados" && o.value != j) {
      const oe = `${w.id}${_}${k.replace(":", "")}`;
      o.value = oe;
      const le = 398, de = 190, g = S(b), D = C(b), y = Z(b), I = Q(b);
      g >= le ? t.value = "right" : D >= le ? t.value = "left" : I >= de ? t.value = "bottom" : y >= de ? t.value = "top" : t.value = "right";
    }
  }, m = (b, w, _, k) => {
    s.value = { target: b, item: w, columnIndex: _, hour: k };
  }, f = () => {
    a.value = !1, n = null, l.value = null;
  }, u = (b) => {
    a.value = !0, n = b, l.value = b;
  }, c = (b, w, _) => `${b}${w}${_.replace(":", "")}`, S = (b) => {
    const w = b.getBoundingClientRect(), _ = e.value.getBoundingClientRect();
    return _.width - (w.right - _.left);
  }, C = (b) => {
    const w = b.getBoundingClientRect(), _ = e.value.getBoundingClientRect();
    return w.left - _.left;
  }, Z = (b) => {
    const w = b.getBoundingClientRect(), _ = e.value.getBoundingClientRect();
    return w.top - _.top;
  }, Q = (b) => {
    const w = b.getBoundingClientRect(), _ = e.value.getBoundingClientRect();
    return _.height - (w.bottom - _.top);
  }, U = () => {
    o.value = null;
  }, J = (b) => {
    u(b), U();
  }, ne = () => {
    const { target: b, item: w, columnIndex: _, hour: k } = s.value;
    v(b, w, _, k), s.value = null;
  };
  return {
    currentPopup: o,
    popupPosition: t,
    atClosePopup: U,
    getCurrentPopupKey: c,
    clickedOutside: J,
    removedItem: () => {
      s.value && ne(), f();
    },
    calendarItemWasClicked: (b, w, _, k) => {
      console.log("calendarItemWasClicked popup");
      const j = c(w.id, _, k);
      if (r(j)) {
        f();
        return;
      }
      l.value != null ? m(b, w, _, k) : v(b, w, _, k);
    }
  };
}
const Fs = [
  { header: "#2caeb4", body: "rgba(113, 213, 211, 0.87)" },
  { header: "#7979d2", body: "rgba(160, 160, 229, 0.87)" },
  { header: "#e76050", body: "rgba(231, 120, 114, 0.87)" },
  { header: "#f1b555", body: "rgba(252, 205, 121, 0.87)" },
  { header: "#5a93db", body: "rgba(127, 179, 244, 0.87)" },
  { header: "#ec8529", body: "rgba(247, 164, 109, 0.87)" },
  { header: "#6d4a42", body: "rgba(157, 122, 110, 0.87)" },
  { header: "#DB8180", body: "rgba(233, 176, 175, 0.87)" },
  { header: "#698C7D", body: "rgba(174, 194, 185, 0.87)" },
  { header: "#A59F8D", body: "rgba(201, 197, 186, 0.87)" },
  { header: "#9c27b0", body: "rgba(169, 68, 178, 0.87)" },
  { header: "#e91e63", body: "rgba(244, 143, 177, 0.87)" },
  { header: "#673ab7", body: "rgba(144, 101, 181, 0.87)" },
  { header: "#3f51b5", body: "rgba(120, 144, 237, 0.87)" },
  { header: "#009688", body: "rgba(97, 207, 184, 0.87)" },
  { header: "#4caf50", body: "rgba(139, 226, 138, 0.87)" },
  { header: "#ff5722", body: "rgba(255, 151, 120, 0.87)" },
  { header: "#795548", body: "rgba(158, 133, 117, 0.87)" },
  { header: "#607d8b", body: "rgba(140, 158, 173, 0.87)" },
  { header: "#ff9800", body: "rgba(255, 183, 77, 0.87)" },
  { header: "#2196f3", body: "rgba(98, 176, 242, 0.87)" },
  { header: "#9e9e9e", body: "rgba(179, 179, 179, 0.87)" },
  { header: "#ffeb3b", body: "rgba(255, 237, 140, 0.87)" },
  { header: "#cddc39", body: "rgba(186, 212, 83, 0.87)" },
  { header: "#8bc34a", body: "rgba(148, 208, 91, 0.87)" },
  { header: "#ff5722", body: "rgba(255, 151, 120, 0.87)" },
  { header: "#f44336", body: "rgba(248, 91, 76, 0.87)" },
  { header: "#9c27b0", body: "rgba(169, 68, 178, 0.87)" },
  { header: "#3f51b5", body: "rgba(120, 144, 237, 0.87)" },
  { header: "#4caf50", body: "rgba(139, 226, 138, 0.87)" }
];
function Es(e) {
  const { printmode: o, aulas: t } = Je(e), { shortcalendar: a } = e, n = P([]), s = P(0), l = P({ 2: 0, 3: 0, 4: 0, 5: 0, 6: 0, 7: 0, 1: 0 }), r = P({ 2: 0, 3: 0, 4: 0, 5: 0, 6: 0, 7: 0, 1: 0 }), v = P({ start: 7, end: 23 }), m = x(() => {
    const g = t.value.map((y) => {
      const I = y.cadeira == "Feriados" ? "Feriado" : y.cadeira;
      return {
        ...y,
        cadeira: I,
        horaInicio: `${y.horaInicio}:00`,
        horaFim: `${y.horaFim}:00`
      };
    });
    return {
      2: g.filter((y) => y.idDiaSemana == 2),
      3: g.filter((y) => y.idDiaSemana == 3),
      4: g.filter((y) => y.idDiaSemana == 4),
      5: g.filter((y) => y.idDiaSemana == 5),
      6: g.filter((y) => y.idDiaSemana == 6),
      7: g.filter((y) => y.idDiaSemana == 7),
      1: g.filter((y) => y.idDiaSemana == 1)
    };
  }), f = x(() => {
    const g = [
      ...new Set(
        t.value.map((y) => y.cadeira == "Feriados" ? "Feriado" : y.cadeira)
      )
    ], D = {};
    return g.map((y, I) => {
      D[y] = Fs[I];
    }), D;
  }), u = x(
    () => Object.values(l.value).some((g) => g > 3)
  ), c = (g, D) => {
    const y = D.replace(":", "");
    return `${g}${y}`;
  }, S = (g) => ue(g) ? g.join(", ") : g, C = (g) => g == "Feriados" ? "" : g, Z = (g) => ue(g) ? g.join(", ") : g, Q = (g) => {
    const [D, y] = g.split(":").map(Number);
    return D * 60 + y;
  }, U = (g, D) => {
    const y = Q(g), V = (Q(D) - y) / 30;
    return Math.abs(V);
  }, J = (g, D) => D == 0.5 ? `${g.toString().padStart(2, "0")}:00:00` : `${(g === 0 ? 23 : g - 1).toString().padStart(2, "0")}:30:00`, ne = (g) => `${g.toString().padStart(2, "0")}:30:00`, he = (g) => {
    const D = v.value.start - Math.floor(v.value.start);
    v.value.start > 7 && (g.horaInicio = J(
      parseInt(v.value.start),
      D
    )), v.value.end < 23.5 && (g.horaFim = ne(parseInt(v.value.end))), g.duracao = U(g.horaInicio, g.horaFim) + 1;
  }, O = x(() => {
    const g = {};
    return de.value.columns.forEach((D, y) => {
      D.forEach((I) => {
        (I.Tipo == "feriados" || I.Tipo == "ferias") && he(I);
        const { horaInicio: V, duracao: X } = I, N = V.substring(0, V.length - 3), K = c(y, N);
        g[K] || (g[K] = {
          events: []
        }), X < Be && b(K, X).map((re) => {
          n.value.push({ el: re, element: I });
        }), I.cadeira = I.Tipo == "feriados" ? "Feriado" : I.cadeira, I.truncate = X < Be && I.cadeira.length > 19, o.value && (I.truncate = !1), I.bodycolor = f.value[I.cadeira].body, I.headercolor = f.value[I.cadeira].header, I.tipo = C(I.tipo), I.docente = Z(I.docente), I.sala = S(I.sala_desc), I.sala_desc = S(I.sala_desc), g[K].events.push(I);
      });
    }), g;
  }), b = (g, D) => {
    var y = [parseInt(g)], I = g % 100 == 30 ? 70 : 30;
    for (let V = 0; V < D - 1; V++)
      y.push(parseInt(y[V]) + I), I = I > 30 ? 30 : 70;
    return y.map((V) => V.toString());
  }, w = (g, D) => {
    g.push([D]);
  }, _ = (g, D) => !g || !D ? !1 : g.length == 0 ? !0 : g[g.length - 1].horaFim <= D.horaInicio, k = (g, D) => {
    let y = !1;
    for (const I of D)
      if (_(I, g)) {
        I.push(g), y = !0;
        break;
      }
    return y;
  }, j = (g, D, y) => g.length == 0 && D[y] > 1 && D[y] < 7, oe = (g) => {
    const [D, y] = g.split(":").map(Number);
    return D + y / 60;
  }, le = (g) => {
    let D = 7, y = 23;
    if (a) {
      let I = g.reduce((X, N) => N.length > 0 && (X === "" || X > N[0].horaInicio) && N[0].Tipo != "feriados" && N[0].Tipo != "ferias" ? N[0].horaInicio : X, "");
      D = I !== "" ? oe(I) : 7;
      let V = g.reduce((X, N) => (N.forEach((K) => {
        X < K.horaFim && N[0].Tipo != "feriados" && N[0].Tipo != "ferias" && (X = K.horaFim);
      }), X), "");
      y = V !== "" ? oe(V) : 23;
    }
    v.value = {
      start: D,
      end: y
    };
  }, de = x(() => {
    let g = [];
    const D = [2, 3, 4, 5, 6, 7, 1];
    D.map((X) => {
      let N = m.value[X];
      N.sort((K, re) => K.horaInicio.localeCompare(re.horaInicio)), g.push(N);
    });
    let y = [], I = [], V = 0;
    return g.forEach((X, N) => {
      let K = [];
      X.forEach((re) => {
        k(re, K) || w(K, re), I.push(re);
      }), j(K, D, N) && (K = [[]]), V = V + K.length, l.value[D[N]] = K.length, r.value[D[N]] = V, y = [...y, ...K];
    }), s.value = y.length, le(y), {
      aulas: I,
      columns: y
    };
  });
  return {
    calendario: m,
    smallEventos: n,
    totalcolumns: s,
    headerSize: l,
    headerColumnEnd: r,
    smallfont: u,
    eventosGrid: O,
    hoursRange: v
  };
}
function Ms(e) {
  const o = P([]), t = x(() => o.value.length == 0 ? "0px" : `${595 / o.value.length}px`), a = (m, f) => `${m.id}${f}${m.idDiaSemana}${m.horaInicio}${m.horaFim}`, n = P({}), s = (m, f, u) => {
    m && (n.value[a(f, u)] = m.$el);
  }, l = P(0), r = x(() => Object.values(e.value).map((m) => m.events).flat().filter((m) => m.Tipo != "feriados" && m.duracao < 3)), v = () => {
    if (r.value.length === 0)
      return Ge;
    r.value.forEach((m, f) => {
      const u = n.value[a(m, f)];
      if (u) {
        let c = u.offsetHeight / m.duracao;
        c > l.value && (l.value = c);
      }
    }), l.value += 5;
  };
  return ye(() => {
    ke(() => {
      v();
    });
  }), {
    printCellSize: l,
    aulasWithSmallSize: r,
    setAulaRef: s,
    width: t,
    columnsRefs: o
  };
}
const Ls = {
  props: [
    "weekstart",
    "aulas",
    "shortcalendar",
    "nohour",
    "cellheigth",
    "smallCellMultiplier",
    "lang",
    "eventoCellHeigth",
    "printmode",
    "showall"
  ],
  name: "calendario",
  components: {
    CalendarItem: Qa,
    HeaderGrid: Is,
    HourGrid: As,
    Bodygrid: Os,
    CalendarPopup: ns,
    PopupContent: ms
  },
  setup(e) {
    const {
      calendario: o,
      smallEventos: t,
      totalcolumns: a,
      headerSize: n,
      headerColumnEnd: s,
      smallfont: l,
      eventosGrid: r,
      calendarKey: v,
      hoursRange: m
    } = Es(e), f = P([]), u = P(null), c = x(() => {
      let H = {};
      for (var M = 1; M < 8; M++)
        H[M] = o.value[M].length;
      return H;
    }), S = 30, C = x(() => {
      const H = [];
      let M = m.value?.start, z = m.value?.end, G = Math.floor(M), Y = (M - G) * 60;
      M > 7 && (Y -= 30, Y < 0 && (G -= 1, Y += 60));
      for (let _e = G; _e <= z; _e++) {
        for (let Ce = Y; Ce < 60; Ce += S) {
          const Ye = _e.toString().padStart(2, "0"), Ue = Math.floor(Ce).toString().padStart(2, "0");
          H.push(`${Ye}:${Ue}`);
        }
        Y = 0;
      }
      return H;
    });
    (() => {
      u.value = /* @__PURE__ */ new Set(), t.value.forEach((H) => {
        const { el: M, element: z } = H;
        let G = M.slice(-4);
        [...Array(a.value).keys()].map((Y) => {
          const _e = `${Y + 1}${G}`;
          u.value.add(_e);
        });
      });
    })();
    const Q = P(null), U = P(0), J = P(null), ne = () => {
      const H = Q.value;
      if (H) {
        const M = H.$el.offsetHeight, z = window.getComputedStyle(H.$el);
        return ["top", "bottom"].map((G) => parseInt(z[`margin-${G}`])).reduce((G, Y) => G + Y, M);
      }
    }, he = (H) => {
      var M = H.getBoundingClientRect();
      return M.top + window.scrollY;
    }, O = () => {
      const H = window.getComputedStyle(document.body), M = parseInt(H.marginBottom, 10), z = parseInt(H.paddingBottom, 10);
      return M + z;
    }, b = () => {
      if (!J.value)
        return;
      const H = ne(), M = he(J.value), z = O(), G = M + H, Y = window.innerHeight - G - z - 25, _e = Math.max(0, Y);
      U.value = `${_e}px`;
    };
    ye(() => {
      b(), window.addEventListener("resize", b);
    }), ge(() => e.aulas, (H) => {
      b();
    });
    const w = (H) => ({
      firstcellday: H == 1,
      lastcellday: H == a.value,
      endDay: _(H)
    }), _ = (H) => {
      var M = Object.values(s.value).findIndex((z) => z == H);
      return M > -1;
    }, {
      printCellSize: k,
      aulasWithSmallSize: j,
      setAulaRef: oe,
      width: le,
      columnsRefs: de
    } = Ms(r), g = (H, M) => {
      const z = M.replace(":", "");
      return `${H}${z}`;
    }, D = x(() => e.printmode && k.value > 0 ? k.value : e.cellheigth ?? Ge), y = P(Ps), I = (H, M, z) => {
      let G = D.value * z.duracao;
      return e.printmode && (z.Tipo == "feriados" || z.Tipo == "ferias") && (G = G - 5), `${G}px`;
    }, V = (H, M) => {
      const z = g(H, M), G = r.value[z]?.events;
      return G != null ? G.map((Y) => ({
        ...Y,
        horaInicio: Y.horaInicio.substring(0, Y.horaInicio.length - 3),
        horaFim: Y.horaFim.substring(0, Y.horaFim.length - 3)
      })) : [];
    }, {
      currentPopup: X,
      popupPosition: N,
      atClosePopup: K,
      getCurrentPopupKey: re,
      clickedOutside: Ae,
      removedItem: qe,
      calendarItemWasClicked: Xe
    } = Hs(J);
    return {
      columnsRefs: de,
      width: le,
      setAulaRef: oe,
      aulasWithSmallSize: j,
      hoursKeys: C,
      days: f,
      cellsWithLargerHeight: u,
      numberOfEventsPerDay: c,
      calendarheader: Q,
      bodyheight: U,
      calendarframe: J,
      getClassesForDayColumn: w,
      getaulaHeight: I,
      getEventsForCurrentCellColumn: V,
      calculatedCellHeigth: D,
      calculatedSmallCellMultiplier: y,
      currentPopup: X,
      popupPosition: N,
      atClosePopup: K,
      calendarItemWasClicked: Xe,
      clickedOutside: Ae,
      removedItem: qe,
      getCurrentPopupKey: re,
      totalcolumns: a,
      headerSize: n,
      smallfont: l,
      calendarKey: v
    };
  }
}, Ws = (e) => (ee("data-v-3a8265f1"), e = e(), te(), e), Bs = {
  class: "gridbackground",
  ref: "calendarframe"
}, Ns = /* @__PURE__ */ Ws(() => /* @__PURE__ */ d("br", null, null, -1));
function Rs(e, o, t, a, n, s) {
  const l = L("HeaderGrid"), r = L("HourGrid"), v = L("CalendarItem"), m = L("PopupContent"), f = L("CalendarPopup"), u = L("Bodygrid");
  return i(), h("div", Bs, [
    q(l, {
      ref: "calendarheader",
      lang: t.lang,
      start: t.weekstart,
      numberOfEventsPerDay: a.numberOfEventsPerDay,
      headersize: a.headerSize,
      totalcolumns: a.totalcolumns
    }, null, 8, ["lang", "start", "numberOfEventsPerDay", "headersize", "totalcolumns"]),
    q(u, {
      totalcolumns: a.totalcolumns,
      showall: t.showall,
      bodyheight: a.bodyheight,
      ref: "bodygrid"
    }, {
      default: ae(() => [
        q(r, {
          hours: a.hoursKeys,
          showall: t.showall,
          calculatedSmallCellMultiplier: a.calculatedSmallCellMultiplier,
          calculatedCellHeigth: a.calculatedCellHeigth,
          totalcolumns: a.totalcolumns,
          cellsWithLargerHeight: a.cellsWithLargerHeight
        }, null, 8, ["hours", "showall", "calculatedSmallCellMultiplier", "calculatedCellHeigth", "totalcolumns", "cellsWithLargerHeight"]),
        (i(!0), h(F, null, R(a.totalcolumns, (c) => (i(), h("div", {
          ref_for: !0,
          ref: "columnsRefs",
          key: c,
          class: $(a.getClassesForDayColumn(c))
        }, [
          (i(!0), h(F, null, R(a.hoursKeys, (S) => (i(), h("div", {
            class: "hourcell",
            style: T({ height: `${a.calculatedCellHeigth}px` })
          }, [
            (i(!0), h(F, null, R(a.getEventsForCurrentCellColumn(c - 1, S), (C) => (i(), h(F, {
              key: `${C.cadeira}${c}${S}`
            }, [
              E(e.$slots, "calendarItem", {
                smallfont: a.smallfont,
                item: C,
                lang: t.lang,
                getaulaHeight: a.getaulaHeight,
                getCurrentPopupKey: a.getCurrentPopupKey,
                currentPopup: a.currentPopup,
                columnIndex: c,
                hour: S,
                popupPosition: a.popupPosition,
                calendarItemWasClicked: a.calendarItemWasClicked,
                clickedOutside: a.clickedOutside,
                atClosePopup: a.atClosePopup,
                removedItem: a.removedItem
              }, () => [
                q(v, {
                  class: "citem",
                  onClick: (Z) => a.calendarItemWasClicked(Z.currentTarget, C, c, S),
                  smallfont: a.smallfont,
                  sala: C.sala_desc,
                  professor: C.docente,
                  disciplina: C.cadeira,
                  piso: C.piso,
                  tipo: C.tipo,
                  truncate: C.truncate,
                  lang: t.lang,
                  horaInicio: C.horaInicio,
                  horaFim: C.horaFim,
                  duracao: C.duracao,
                  aulaHeight: a.getaulaHeight(c, S, C),
                  colorbackground: C.bodycolor,
                  colorheader: C.headercolor,
                  showlabel: C.duracao > 3,
                  ref_for: !0,
                  ref: a.getCurrentPopupKey(C.id, c, S)
                }, null, 8, ["onClick", "smallfont", "sala", "professor", "disciplina", "piso", "tipo", "truncate", "lang", "horaInicio", "horaFim", "duracao", "aulaHeight", "colorbackground", "colorheader", "showlabel"])
              ], !0),
              E(e.$slots, "popup", {
                columnIndex: c,
                hour: S,
                getCurrentPopupKey: a.getCurrentPopupKey,
                item: C,
                "tipo:": C.Tipo,
                currentPopup: a.currentPopup,
                popupPosition: a.popupPosition,
                clickedOutside: a.clickedOutside,
                atClosePopup: a.atClosePopup,
                lang: t.lang,
                removedItem: a.removedItem
              }, () => [
                C.Tipo != "feriados" ? (i(), se(f, {
                  key: 0,
                  numberOfCells: C.duracao,
                  isVisible: a.currentPopup == a.getCurrentPopupKey(C.id, c, S),
                  position: a.popupPosition,
                  itemkey: a.getCurrentPopupKey(C.id, c, S),
                  onRemoved: a.removedItem,
                  onOutside: (Z) => a.clickedOutside(a.getCurrentPopupKey(C.id, c, S)),
                  onClose: a.atClosePopup
                }, {
                  default: ae(() => [
                    q(m, {
                      lang: t.lang,
                      horaInicio: C.horaInicio,
                      horaFim: C.horaFim,
                      cadeira: C.cadeira,
                      sala: C.sala_desc,
                      piso: C.piso,
                      tipo: C.tipo,
                      color: C.bodycolor,
                      docente: C.docente
                    }, null, 8, ["lang", "horaInicio", "horaFim", "cadeira", "sala", "piso", "tipo", "color", "docente"])
                  ]),
                  _: 2
                }, 1032, ["numberOfCells", "isVisible", "position", "itemkey", "onRemoved", "onOutside", "onClose"])) : B("", !0)
              ], !0)
            ], 64))), 128))
          ], 4))), 256))
        ], 2))), 128))
      ]),
      _: 3
    }, 8, ["totalcolumns", "showall", "bodyheight"]),
    (i(!0), h(F, null, R(a.aulasWithSmallSize, (c, S) => (i(), h("div", {
      key: `offscreen-${c.id}`,
      class: "offscreen",
      style: T({ width: a.width })
    }, [
      q(v, {
        ref_for: !0,
        ref: (C) => a.setAulaRef(C, c, S),
        class: "citem ghost",
        smallfont: !1,
        sala: c.sala_desc,
        professor: c.docente,
        disciplina: c.cadeira,
        piso: c.piso,
        tipo: c.tipo,
        truncate: !1,
        lang: t.lang,
        horaInicio: c.horaInicio,
        horaFim: c.horaFim,
        duracao: c.duracao,
        colorbackground: c.bodycolor,
        colorheader: c.headercolor,
        showlabel: c.duracao > 3
      }, {
        secondary: ae(({ tipo: C, sala: Z, pisolabel: Q, piso: U }) => [
          C.length > 0 ? (i(), h(F, { key: 0 }, [
            W("[" + p(C) + "]", 1)
          ], 64)) : B("", !0),
          W(" " + p(Z) + " ", 1),
          U != null ? (i(), h(F, { key: 1 }, [
            W("- " + p(Q) + " " + p(U), 1)
          ], 64)) : B("", !0),
          Ns,
          W(" Docente: " + p(c.docente), 1)
        ]),
        _: 2
      }, 1032, ["sala", "professor", "disciplina", "piso", "tipo", "lang", "horaInicio", "horaFim", "duracao", "colorbackground", "colorheader", "showlabel"])
    ], 4))), 128))
  ], 512);
}
const Cn = /* @__PURE__ */ A(Ls, [["render", Rs], ["__scopeId", "data-v-3a8265f1"]]), Vs = [
  { header: "#2caeb4", body: "rgba(113, 213, 211, 0.87)" },
  { header: "#7979d2", body: "rgba(160, 160, 229, 0.87)" },
  { header: "#e76050", body: "rgba(231, 120, 114, 0.87)" },
  { header: "#f1b555", body: "rgba(252, 205, 121, 0.87)" },
  { header: "#5a93db", body: "rgba(127, 179, 244, 0.87)" },
  { header: "#ec8529", body: "rgba(247, 164, 109, 0.87)" },
  { header: "#4e342e", body: "rgba(188, 170, 164, 0.87)" },
  { header: "#DB8180", body: "rgba(233, 176, 175, 0.87)" },
  { header: "#698C7D", body: "rgba(174, 194, 185, 0.87)" },
  { header: "#A59F8D", body: "rgba(201, 197, 186, 0.87)" },
  { header: "#9c27b0", body: "rgba(169, 68, 178, 0.87)" },
  { header: "#e91e63", body: "rgba(244, 143, 177, 0.87)" },
  { header: "#673ab7", body: "rgba(144, 101, 181, 0.87)" },
  { header: "#3f51b5", body: "rgba(120, 144, 237, 0.87)" },
  { header: "#009688", body: "rgba(97, 207, 184, 0.87)" },
  { header: "#4caf50", body: "rgba(139, 226, 138, 0.87)" },
  { header: "#ff5722", body: "rgba(255, 151, 120, 0.87)" },
  { header: "#795548", body: "rgba(158, 133, 117, 0.87)" },
  { header: "#607d8b", body: "rgba(140, 158, 173, 0.87)" },
  { header: "#ff9800", body: "rgba(255, 183, 77, 0.87)" },
  { header: "#2196f3", body: "rgba(98, 176, 242, 0.87)" },
  { header: "#9e9e9e", body: "rgba(179, 179, 179, 0.87)" },
  { header: "#ffeb3b", body: "rgba(255, 237, 140, 0.87)" },
  { header: "#cddc39", body: "rgba(186, 212, 83, 0.87)" },
  { header: "#8bc34a", body: "rgba(148, 208, 91, 0.87)" },
  { header: "#ff5722", body: "rgba(255, 151, 120, 0.87)" },
  { header: "#f44336", body: "rgba(248, 91, 76, 0.87)" },
  { header: "#9c27b0", body: "rgba(169, 68, 178, 0.87)" },
  { header: "#3f51b5", body: "rgba(120, 144, 237, 0.87)" },
  { header: "#4caf50", body: "rgba(139, 226, 138, 0.87)" }
];
const Ks = {
  name: "eventItem",
  props: [
    "colorbackground",
    "colorseparador",
    "disciplina",
    "sala",
    "professor",
    "tipo",
    "horaInicio",
    "horaFim",
    "ano",
    "turma",
    "piso"
  ],
  computed: {
    eventStyle() {
      return {
        "background-color": this.colorbackground
      };
    },
    leftStyle() {
      return {
        "border-right": `2px solid ${this.colorseparador}`
      };
    },
    startHour() {
      return this.horaInicio.slice(0, 5);
    },
    endHour() {
      return this.horaFim.slice(0, 5);
    },
    otherText() {
      let e = this.professor.length > 0 ? `(${this.getDocenteLabel(this.professor)})` : "", o = this.ano > -1 ? `- ${this.ano}\xBA Ano` : "";
      return `${this.tipo} ${e} ${o}`;
    }
  },
  methods: {
    getDocenteLabel(e) {
      return ue(e) ? e.join(", ") : e;
    },
    formatSala(e) {
      return ue(e) ? e.join(", ") : e;
    }
  }
}, js = { class: "event-item-info" }, zs = { class: "disciplina" }, Gs = { class: "other" }, qs = { class: "sala" };
function Xs(e, o, t, a, n, s) {
  return i(), h("div", {
    class: "event-item",
    style: T(s.eventStyle)
  }, [
    d("div", {
      class: "event-item-hours",
      style: T(s.leftStyle)
    }, [
      d("span", null, p(s.startHour), 1),
      d("span", null, p(s.endHour), 1)
    ], 4),
    d("div", js, [
      d("div", zs, p(t.disciplina), 1),
      d("div", Gs, p(s.otherText), 1),
      d("div", qs, [
        W(p(s.formatSala(t.sala)), 1),
        t.piso != null ? (i(), h(F, { key: 0 }, [
          W(" - Piso " + p(t.piso), 1)
        ], 64)) : B("", !0)
      ])
    ])
  ], 4);
}
const Ys = /* @__PURE__ */ A(Ks, [["render", Xs], ["__scopeId", "data-v-041b4904"]]);
let Ne = null, Re = null;
const Us = {
  name: "mev",
  props: [
    "aulas",
    "selectedWeek",
    "showEmptyDays",
    "lang"
  ],
  emits: ["changeDay"],
  components: {
    EventItem: Ys
  },
  setup(e, { emit: o }) {
    const t = x(() => {
      const O = [...new Set(e.aulas.map((w) => w.cadeira == "Feriados" ? "Feriado" : w.cadeira))], b = {};
      return O.map((w, _) => {
        b[w] = Vs[_];
      }), b;
    }), a = ["2", "3", "4", "5", "6", "7", "1"], n = P({}), s = () => {
      const O = e.aulas.map((b) => (b.cadeira = b.Tipo == "feriados" ? "Feriado" : b.cadeira, {
        ...b
      }));
      a.map((b) => {
        n.value[b] = O.filter((w) => w.idDiaSemana == b);
      });
    }, l = x(() => {
      s();
      const O = Object.entries(n.value);
      O.sort((w, _) => w[0] - _[0]);
      for (const [, w] of O)
        w.sort((_, k) => _.horaInicio.localeCompare(k.horaInicio));
      const b = O.pop();
      return b[0] === "1" ? O.push(b) : O.unshift(b), Object.fromEntries(O);
    }), r = P([]), v = P([]), m = e.lang == "pt" ? "pt-PT" : "en-uk";
    Ne = new Intl.DateTimeFormat(m, {
      weekday: "long"
    }), Re = new Intl.DateTimeFormat(m, {
      day: "2-digit",
      month: "long"
    }), (() => {
      let O = new Date(e.selectedWeek.start.getTime());
      for (var b = 0; b < 7; b++)
        r.value.push(Ne.format(O).toUpperCase()), v.value.push(Re.format(O).toUpperCase()), O.setDate(O.getDate() + 1);
    })();
    const u = P(null), c = P([]), S = () => {
      document.querySelectorAll("div.section").forEach((b) => {
        c.value.push(b.offsetTop);
      }), u.value = a[0];
    }, C = P(0), Z = P(null), Q = P(null), U = P(null), J = () => {
      const O = parseInt(window.getComputedStyle(Z.value).paddingTop, 10), b = parseInt(window.getComputedStyle(Z.value).paddingBottom, 10);
      return O + b;
    }, ne = () => {
      const O = U.value.clientHeight, b = Q.value[0].clientHeight, w = J();
      C.value = O - b - w - 10;
    };
    return ge(() => e.aulas, (O) => {
      ke(() => {
        S(), ne();
      });
    }, { deep: !0 }), {
      aulascolor: t,
      sortedCalendario: l,
      sortedKeys: a,
      days: r,
      daysname: v,
      handleScroll: () => {
        const O = U.value.scrollTop, b = c.value.findLastIndex((_) => _ - 20 < O), w = a[b];
        w != null && u.value != w && (u.value = w, o("changeDay", w));
      },
      eventListContainer: U,
      evlist: Z,
      spacerHeight: C,
      currentDay1: Q,
      currentSection: u
    };
  },
  methods: {
    scrollToDay(e) {
      this.$refs[`currentDay${e}`] && (this.$refs[`currentDay${e}`][0].scrollIntoView({ behavior: "smooth", block: "start" }), this.currentSection = e);
    }
  }
}, Zs = (e) => (ee("data-v-2b15e87a"), e = e(), te(), e), Qs = {
  class: "eventlist",
  ref: "evlist"
}, Js = { key: 0 }, en = /* @__PURE__ */ Zs(() => /* @__PURE__ */ d("i", {
  class: "ms-Icon ms-Icon--Warning",
  title: "Warning",
  "aria-hidden": "true"
}, null, -1));
function tn(e, o, t, a, n, s) {
  const l = L("EventItem");
  return i(), h("div", {
    onScroll: o[0] || (o[0] = (...r) => a.handleScroll && a.handleScroll(...r)),
    class: "event-list-container",
    ref: "eventListContainer"
  }, [
    d("div", Qs, [
      (i(!0), h(F, null, R(a.sortedKeys, (r, v) => (i(), h("div", {
        key: r,
        ref_for: !0,
        ref: `currentDay${a.sortedKeys[v]}`,
        class: "section"
      }, [
        d("h2", null, [
          E(e.$slots, "sectionheader", {}, () => [
            W(p(a.days[v]) + " - " + p(a.daysname[v]), 1)
          ], !0)
        ]),
        E(e.$slots, "noresults", {}, () => [
          a.sortedCalendario[r].length == 0 && t.showEmptyDays ? (i(), h("p", Js, [
            en,
            E(e.$slots, "noresultsmsg", {}, () => [
              W(" N\xE3o existem eventos neste dia ")
            ], !0)
          ])) : B("", !0)
        ], !0),
        (i(!0), h(F, null, R(a.sortedCalendario[r], (m) => E(e.$slots, "listitem", {
          key: m.id,
          aulascolor: a.aulascolor,
          item: m
        }, () => [
          q(l, {
            class: "eventItem",
            colorbackground: a.aulascolor[m.cadeira].body,
            colorseparador: a.aulascolor[m.cadeira].header,
            horaInicio: m.horaInicio,
            horaFim: m.horaFim,
            disciplina: m.cadeira,
            tipo: m.tipo,
            sala: m.sala_desc,
            ano: m.ano,
            turma: m.turma,
            professor: m.docente,
            piso: m.piso
          }, null, 8, ["colorbackground", "colorseparador", "horaInicio", "horaFim", "disciplina", "tipo", "sala", "ano", "turma", "professor", "piso"])
        ], !0)), 128))
      ], 512))), 128))
    ], 512),
    d("div", {
      class: "spacer",
      style: T({ height: a.spacerHeight + "px" })
    }, null, 4)
  ], 544);
}
const Sn = /* @__PURE__ */ A(Us, [["render", tn], ["__scopeId", "data-v-2b15e87a"]]);
const on = {
  props: {
    text: String
  },
  setup() {
    const e = Pe("closeAllTooltips", () => {
    }), o = Pe("registerTooltip", () => {
    }), t = P(!1), a = P("fade"), n = P(null), s = () => {
      e(), a.value = "fade", t.value = !0;
    }, l = () => {
      n.value = setTimeout(() => {
        a.value = "fade", t.value = !1;
      }, 100);
    }, r = () => {
      clearTimeout(n.value), a.value = "disappear", t.value = !1;
    };
    return ye(() => {
      o({ showTooltip: s, hideTooltip: l, closeImmediately: r });
    }), {
      show: t,
      transitionName: a,
      hideTimeout: n,
      showTooltip: s,
      hideTooltip: l,
      closeImmediately: r
    };
  }
}, an = {
  key: 0,
  class: "tooltip-content"
};
function sn(e, o, t, a, n, s) {
  return i(), h("div", {
    class: "tooltip-container",
    onMouseenter: o[0] || (o[0] = (...l) => a.showTooltip && a.showTooltip(...l)),
    onMouseleave: o[1] || (o[1] = (...l) => a.hideTooltip && a.hideTooltip(...l))
  }, [
    E(e.$slots, "default", {}, void 0, !0),
    q(Ve, { name: a.transitionName }, {
      default: ae(() => [
        a.show ? (i(), h("div", an, p(t.text), 1)) : B("", !0)
      ]),
      _: 1
    }, 8, ["name"])
  ], 32);
}
const kn = /* @__PURE__ */ A(on, [["render", sn], ["__scopeId", "data-v-4c9dd40c"]]), nn = {
  provide() {
    return {
      closeAllTooltips: this.closeAllTooltips,
      registerTooltip: this.registerTooltip
    };
  },
  data() {
    return {
      tooltips: []
    };
  },
  methods: {
    registerTooltip(e) {
      this.tooltips.push(e);
    },
    closeAllTooltips() {
      this.tooltips.forEach((e) => e.closeImmediately());
    }
  }
};
function rn(e, o, t, a, n, s) {
  return E(e.$slots, "default");
}
const In = /* @__PURE__ */ A(nn, [["render", rn]]);
export {
  bn as AvalList,
  mn as BreadCrumb,
  Qa as CalendarItem,
  ns as CalendarPopup,
  un as ComboBoxSearch,
  hn as ComboSearch,
  cn as Combobox,
  xa as EventItem,
  yn as EventList,
  gn as LinkButton,
  ms as PopupContent,
  vn as SpinText,
  Eo as Spinner,
  _n as TBotao,
  fn as TBotaoIcon,
  it as TestemunhoRow,
  Co as TodayButton,
  kn as Tooltip,
  In as TooltipManager,
  dn as WebSlider,
  Cn as calendario,
  pn as datesNavigation,
  Sn as mev,
  Ys as mevItem
};
//# sourceMappingURL=umaui.js.map
